var map = {
	"./about/30Years.jpg": "0e39",
	"./about/Marc2000tower.jpg": "9d65",
	"./about/VMCTopManagement.jpg": "950d",
	"./about/allvmcorgchart.jpg": "adcc",
	"./about/quality_crew_7-7-2021.jpg": "9355",
	"./about/topmgmtchart.jpg": "288c",
	"./about/vmc_office_logo-7-7-2021.jpg": "6682",
	"./affiliates/govlogo/ched.jpg": "7625",
	"./affiliates/govlogo/deped.jpg": "511f",
	"./affiliates/govlogo/dfa.jpg": "3053",
	"./affiliates/govlogo/dole.jpg": "b725",
	"./affiliates/govlogo/dotr.jpg": "910f",
	"./affiliates/govlogo/pcg.jpg": "9f4c",
	"./affiliates/govlogo/pdea.jpg": "1610",
	"./affiliates/govlogo/pmma.jpg": "8a08",
	"./affiliates/govlogo/ppa.jpg": "99ed",
	"./affiliates/iso_9001.jpg": "8bbc",
	"./affiliates/iso_9001_dnv.jpg": "7214",
	"./affiliates/klma.jpg": "943e",
	"./affiliates/marina.jpg": "ec2c",
	"./affiliates/pamas.jpg": "7be1",
	"./affiliates/pdos.jpg": "b832",
	"./affiliates/pjmcc.jpg": "ebc7",
	"./affiliates/prc.jpg": "ab41",
	"./affiliates/ukas.jpg": "18f9",
	"./blue_background.jpg": "4035",
	"./car_group.jpg": "a6db",
	"./careers/2025/vmcHiring_03062025.jpg": "cc86",
	"./careers/2025/vmcHiring_04222025.jpg": "ec71",
	"./careers/career_bg.jpg": "036a",
	"./contactus/contact_us_bg.jpg": "3d0e",
	"./crew_group.jpg": "d8ce",
	"./crew_onboarding.jpg": "807c",
	"./crew_onboarding_short.jpg": "3ab0",
	"./crews/cadet_7-7-2021.jpg": "cbaf",
	"./crews/cadet_schooluniform_7-7-2021.jpg": "e47c",
	"./crews/cook_7-7-2021.jpg": "a057",
	"./crews/crew_group.jpg": "befc",
	"./crews/crew_upgrade1_7-7-2021.jpg": "4bf6",
	"./crews/crew_upgrade2_7-7-2021.jpg": "7d2e",
	"./crews/crew_upgrade3_7-7-2021.jpg": "2c2e",
	"./crews/crew_upgrade4_7-7-2021.jpg": "4192",
	"./crews/fastTrackCadetTraining.jpg": "75e2",
	"./crews/inhouseSeminar1.jpg": "cf4f",
	"./crews/inhouseSeminar2.jpg": "04cf",
	"./crews/me1.jpg": "95af",
	"./crews/me2.jpg": "2438",
	"./crews/me3.jpg": "1d77",
	"./crews/otherInHouse1.jpg": "54d9",
	"./crews/otherInHouse2.jpg": "0081",
	"./crews/pre-cadetshipTraining.jpg": "5679",
	"./crews/promotionTraining1.jpg": "b46c",
	"./crews/rating1_7-7-2021.jpg": "686a",
	"./crews/rating2_7-7-2021.jpg": "86fd",
	"./crews/scholarshipTraining.jpg": "2dda",
	"./crews/shipboardTraining.jpg": "b187",
	"./fabric-texture.png": "9197",
	"./keyvisuals - Copy/BicolAllottee2025.jpg": "cfa8",
	"./keyvisuals - Copy/KRBS 4mb.mp4": "f4b8",
	"./keyvisuals - Copy/KRBS 6mb.mp4": "b5f2",
	"./keyvisuals - Copy/Taga_Veritas_Ako_63021.jpg": "4677",
	"./keyvisuals - Copy/VIJAYANAGAR.jpg": "e69c",
	"./keyvisuals - Copy/VeritasFront-Liners_7-12-2019.jpg": "ce4b",
	"./keyvisuals - Copy/assets/about/30Years.jpg": "0b6d",
	"./keyvisuals - Copy/assets/about/Marc2000tower.jpg": "1a54",
	"./keyvisuals - Copy/assets/about/VMCTopManagement.jpg": "2a3b",
	"./keyvisuals - Copy/assets/about/allvmcorgchart.jpg": "9f8d",
	"./keyvisuals - Copy/assets/about/quality_crew_7-7-2021.jpg": "f6f0",
	"./keyvisuals - Copy/assets/about/topmgmtchart.jpg": "af27",
	"./keyvisuals - Copy/assets/about/vmc_office_logo-7-7-2021.jpg": "d269",
	"./keyvisuals - Copy/assets/affiliates/govlogo/ched.jpg": "ea2e",
	"./keyvisuals - Copy/assets/affiliates/govlogo/deped.jpg": "8a90",
	"./keyvisuals - Copy/assets/affiliates/govlogo/dfa.jpg": "99ac",
	"./keyvisuals - Copy/assets/affiliates/govlogo/dole.jpg": "1749",
	"./keyvisuals - Copy/assets/affiliates/govlogo/dotr.jpg": "a97b",
	"./keyvisuals - Copy/assets/affiliates/govlogo/pcg.jpg": "587d",
	"./keyvisuals - Copy/assets/affiliates/govlogo/pdea.jpg": "67b5",
	"./keyvisuals - Copy/assets/affiliates/govlogo/pmma.jpg": "9021",
	"./keyvisuals - Copy/assets/affiliates/govlogo/ppa.jpg": "866d",
	"./keyvisuals - Copy/assets/affiliates/iso_9001.jpg": "a287",
	"./keyvisuals - Copy/assets/affiliates/iso_9001_dnv.jpg": "fd20",
	"./keyvisuals - Copy/assets/affiliates/klma.jpg": "f27b",
	"./keyvisuals - Copy/assets/affiliates/marina.jpg": "69c4",
	"./keyvisuals - Copy/assets/affiliates/pamas.jpg": "30aa",
	"./keyvisuals - Copy/assets/affiliates/pdos.jpg": "6358",
	"./keyvisuals - Copy/assets/affiliates/pjmcc.jpg": "637d",
	"./keyvisuals - Copy/assets/affiliates/prc.jpg": "9321",
	"./keyvisuals - Copy/assets/affiliates/ukas.jpg": "7fdb",
	"./keyvisuals - Copy/assets/blue_background.jpg": "8320",
	"./keyvisuals - Copy/assets/car_group.jpg": "c375",
	"./keyvisuals - Copy/assets/careers/2025/vmcHiring_03062025.jpg": "d9c3",
	"./keyvisuals - Copy/assets/careers/2025/vmcHiring_04222025.jpg": "23e1",
	"./keyvisuals - Copy/assets/careers/career_bg.jpg": "50e1",
	"./keyvisuals - Copy/assets/contactus/contact_us_bg.jpg": "3c21",
	"./keyvisuals - Copy/assets/crew_group.jpg": "9d31",
	"./keyvisuals - Copy/assets/crew_onboarding.jpg": "2a8f",
	"./keyvisuals - Copy/assets/crew_onboarding_short.jpg": "73d4",
	"./keyvisuals - Copy/assets/crews/cadet_7-7-2021.jpg": "7b50",
	"./keyvisuals - Copy/assets/crews/cadet_schooluniform_7-7-2021.jpg": "7c63",
	"./keyvisuals - Copy/assets/crews/cook_7-7-2021.jpg": "4c09",
	"./keyvisuals - Copy/assets/crews/crew_group.jpg": "c948",
	"./keyvisuals - Copy/assets/crews/crew_upgrade1_7-7-2021.jpg": "11fa",
	"./keyvisuals - Copy/assets/crews/crew_upgrade2_7-7-2021.jpg": "9bc8",
	"./keyvisuals - Copy/assets/crews/crew_upgrade3_7-7-2021.jpg": "dd0c",
	"./keyvisuals - Copy/assets/crews/crew_upgrade4_7-7-2021.jpg": "4161",
	"./keyvisuals - Copy/assets/crews/fastTrackCadetTraining.jpg": "118f",
	"./keyvisuals - Copy/assets/crews/inhouseSeminar1.jpg": "59b0",
	"./keyvisuals - Copy/assets/crews/inhouseSeminar2.jpg": "e51e",
	"./keyvisuals - Copy/assets/crews/me1.jpg": "8bd6",
	"./keyvisuals - Copy/assets/crews/me2.jpg": "d915",
	"./keyvisuals - Copy/assets/crews/me3.jpg": "2d82",
	"./keyvisuals - Copy/assets/crews/otherInHouse1.jpg": "79a5",
	"./keyvisuals - Copy/assets/crews/otherInHouse2.jpg": "3d8d",
	"./keyvisuals - Copy/assets/crews/pre-cadetshipTraining.jpg": "79a0",
	"./keyvisuals - Copy/assets/crews/promotionTraining1.jpg": "08ca",
	"./keyvisuals - Copy/assets/crews/rating1_7-7-2021.jpg": "a942",
	"./keyvisuals - Copy/assets/crews/rating2_7-7-2021.jpg": "a5eb",
	"./keyvisuals - Copy/assets/crews/scholarshipTraining.jpg": "6e9b",
	"./keyvisuals - Copy/assets/crews/shipboardTraining.jpg": "e198",
	"./keyvisuals - Copy/assets/fabric-texture.png": "e5dc",
	"./keyvisuals - Copy/assets/keyvisuals/BicolAllottee2025.jpg": "70181",
	"./keyvisuals - Copy/assets/keyvisuals/KRBS 4mb.mp4": "7859",
	"./keyvisuals - Copy/assets/keyvisuals/KRBS 6mb.mp4": "d4bd",
	"./keyvisuals - Copy/assets/keyvisuals/Taga_Veritas_Ako_63021.jpg": "3696",
	"./keyvisuals - Copy/assets/keyvisuals/VIJAYANAGAR.jpg": "47d4",
	"./keyvisuals - Copy/assets/keyvisuals/VeritasFront-Liners_7-12-2019.jpg": "802c",
	"./keyvisuals - Copy/assets/keyvisuals/banner1.jpg": "d40b",
	"./keyvisuals - Copy/assets/keyvisuals/banner2_0.jpg": "e28f",
	"./keyvisuals - Copy/assets/keyvisuals/banner3_0.jpg": "089b",
	"./keyvisuals - Copy/assets/keyvisuals/capebrolga_92921.jpg": "0f3c",
	"./keyvisuals - Copy/assets/keyvisuals/capehayate_032024KV.jpg": "3a4e",
	"./keyvisuals - Copy/assets/keyvisuals/capenormandy_053022KV.jpg": "5cfa",
	"./keyvisuals - Copy/assets/keyvisuals/coronamajesty_053022KV.jpg": "71a1",
	"./keyvisuals - Copy/assets/keyvisuals/covidCaseSep26toOct2-2022KV.jpg": "c0d8",
	"./keyvisuals - Copy/assets/keyvisuals/covid_cases_071122KV.jpg": "caec",
	"./keyvisuals - Copy/assets/keyvisuals/covid_cases_27522KV.jpg": "6e7d",
	"./keyvisuals - Copy/assets/keyvisuals/intlSeafarer_62722KV.jpg": "1b42",
	"./keyvisuals - Copy/assets/keyvisuals/mlcisocert_52022KV.jpg": "9719",
	"./keyvisuals - Copy/assets/keyvisuals/retirees_63021.jpg": "1274",
	"./keyvisuals - Copy/assets/news/2014E015_covid_7-6-2021.jpg": "d072",
	"./keyvisuals - Copy/assets/news/2020/joiningcrew/crew1_7-8-2021.jpg": "043e",
	"./keyvisuals - Copy/assets/news/2020/joiningcrew/crew2_7-8-2021.jpg": "8fcf",
	"./keyvisuals - Copy/assets/news/2020/joiningcrew/crew3_7-8-2021.jpg": "18ac",
	"./keyvisuals - Copy/assets/news/2020/joiningcrew/crew4_7-8-2021.jpg": "9196",
	"./keyvisuals - Copy/assets/news/2020/joiningcrew/crew5_7-8-2021.jpg": "49e4",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office1_7-8-2021.jpg": "fa47",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office2_7-8-2021.jpg": "dd28",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office3_7-8-2021.jpg": "d86f",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office4_7-8-2021.jpg": "2a07",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office5_7-8-2021.jpg": "6bde",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office6_7-8-2021.jpg": "b55d",
	"./keyvisuals - Copy/assets/news/2020/newnormaloffice/office7_7-8-2021.jpg": "4dba",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect1_7-8-2021.jpg": "0f2c",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect2_7-8-2021.jpg": "285f",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect3_7-8-2021.jpg": "ccbf",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect4_7-8-2021.jpg": "1651",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect5_7-8-2021.jpg": "21c8",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect6_7-8-2021.jpg": "1106",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect7_7-8-2021.jpg": "f339",
	"./keyvisuals - Copy/assets/news/2020/tnkcinspection/boqinspect8_7-8-2021.jpg": "208a",
	"./keyvisuals - Copy/assets/news/2020/tnkcswabtest/swab1_7-8-2021.jpg": "eeac",
	"./keyvisuals - Copy/assets/news/2020/tnkcswabtest/swab2_7-8-2021.jpg": "4fbb",
	"./keyvisuals - Copy/assets/news/2020/tnkcswabtest/swab3_7-8-2021.jpg": "e031",
	"./keyvisuals - Copy/assets/news/2021/mis_news_111221.jpg": "1837",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area1_061221.jpg": "bd3a",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area1_211021.jpg": "8355",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area1_thumbnail_061221.jpg": "4e45",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area2_211021.jpg": "4616",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area3_211021.jpg": "60d4",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area4_211021.jpg": "2ffc",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area5_211021.jpg": "d982",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area6_211021.jpg": "909b",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area7_211021.jpg": "3a2d",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area8_211021.jpg": "f7ad",
	"./keyvisuals - Copy/assets/news/2021/vaccinesched/area_thumbnail_211021.jpg": "372c",
	"./keyvisuals - Copy/assets/news/2022/jul/33rd_anniversary_0714-A.jpg": "1ae8",
	"./keyvisuals - Copy/assets/news/2022/jul/33rd_anniversary_0714-B.jpg": "a9da",
	"./keyvisuals - Copy/assets/news/2022/jul/33rd_anniversary_0714-C.jpg": "6d7c",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture1.jpg": "3bd6",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture10.jpg": "9389",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture11.jpg": "5ca8",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture12.jpg": "e9e0",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture13.jpg": "ab1e",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture14.jpg": "a7bc",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture15.jpg": "2bed",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture16.jpg": "6b5a",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture17.jpg": "0065",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture18.jpg": "8ff9",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture19.jpg": "783d",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture2.jpg": "775e",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture3.jpg": "84ee",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture4.jpg": "aa88",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture5.jpg": "a784",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture6.jpg": "2e3b",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture7.jpg": "97c5",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture8.jpg": "e8d4",
	"./keyvisuals - Copy/assets/news/2022/jul/VoyageLifetimeHeritage/Picture9.jpg": "a91e",
	"./keyvisuals - Copy/assets/news/2022/jul/covidCaseJul11to17-2022.jpg": "bc1f",
	"./keyvisuals - Copy/assets/news/2022/jul/covidCaseJul11to17-2022KV.jpg": "2bfc",
	"./keyvisuals - Copy/assets/news/2022/may/Picture1.jpg": "f6e6",
	"./keyvisuals - Copy/assets/news/2022/may/Picture10.jpg": "ac5d",
	"./keyvisuals - Copy/assets/news/2022/may/Picture11.jpg": "f1e2",
	"./keyvisuals - Copy/assets/news/2022/may/Picture12.jpg": "4528",
	"./keyvisuals - Copy/assets/news/2022/may/Picture13.jpg": "7c39",
	"./keyvisuals - Copy/assets/news/2022/may/Picture14.jpg": "d7bb",
	"./keyvisuals - Copy/assets/news/2022/may/Picture15.jpg": "1ffc",
	"./keyvisuals - Copy/assets/news/2022/may/Picture2.jpg": "c43f",
	"./keyvisuals - Copy/assets/news/2022/may/Picture3.jpg": "3afc",
	"./keyvisuals - Copy/assets/news/2022/may/Picture4.jpg": "35d5",
	"./keyvisuals - Copy/assets/news/2022/may/Picture5.jpg": "7372",
	"./keyvisuals - Copy/assets/news/2022/may/Picture6.jpg": "a906",
	"./keyvisuals - Copy/assets/news/2022/may/Picture7.jpg": "c845",
	"./keyvisuals - Copy/assets/news/2022/may/Picture8.jpg": "599c",
	"./keyvisuals - Copy/assets/news/2022/may/Picture9.jpg": "23ea",
	"./keyvisuals - Copy/assets/news/2022/may/covid_cases_27522.jpg": "079d",
	"./keyvisuals - Copy/assets/news/2022/may/covid_cases_27522R.jpg": "4dbe",
	"./keyvisuals - Copy/assets/news/2022/may/mlcisocert_52022-thumbnail.jpg": "f647",
	"./keyvisuals - Copy/assets/news/2022/may/mlcisocert_52022.jpg": "2441",
	"./keyvisuals - Copy/assets/news/2022WomanLikeNoOther.jpg": "d403",
	"./keyvisuals - Copy/assets/news/2023/CrewFamilyXmas.png": "4edc",
	"./keyvisuals - Copy/assets/news/2023/StaffXmasParty.png": "f7ac",
	"./keyvisuals - Copy/assets/news/2024/CebuBohol2024.jpg": "5353",
	"./keyvisuals - Copy/assets/news/2024/IloiloBacolod2024.jpg": "56ea",
	"./keyvisuals - Copy/assets/news/2024/anniversary/Anniversary35A.jpg": "a3f9",
	"./keyvisuals - Copy/assets/news/2024/anniversary/Anniversary35A.png": "0ca5",
	"./keyvisuals - Copy/assets/news/2024/anniversary/Anniversary35B.png": "02fc",
	"./keyvisuals - Copy/assets/news/2024/anniversary/Anniversary35C.png": "dd65",
	"./keyvisuals - Copy/assets/news/2024/anniversary/Anniversary35D.png": "a613",
	"./keyvisuals - Copy/assets/news/SeafarersHeroesOfPandemic2_7-9-2021.jpg": "d1ed",
	"./keyvisuals - Copy/assets/news/SeafarersHeroesOfPandemic_7-9-2021.jpg": "4f4e",
	"./keyvisuals - Copy/assets/news/SeafarersHeroes_home.jpg": "1bc9",
	"./keyvisuals - Copy/assets/news/TeodoroLocsinMessage25June2021.jpg": "7bea",
	"./keyvisuals - Copy/assets/news/TeodoroLocsinMessage_home.jpg": "9827",
	"./keyvisuals - Copy/assets/news/govt_advisory_template.jpg": "7169",
	"./keyvisuals - Copy/assets/news/medalist_cv_tokyo2020-08_08_2021.jpg": "ae65",
	"./keyvisuals - Copy/assets/news/medalist_tokyo2020-08_08_2021.jpg": "ee67",
	"./keyvisuals - Copy/assets/news/newsStaff_7-10-2021.jpg": "d41a",
	"./keyvisuals - Copy/assets/news/news_10-03-2021.jpg": "d00c",
	"./keyvisuals - Copy/assets/news/news_17-06-2019.jpg": "c4d8",
	"./keyvisuals - Copy/assets/news/news_28-04-2021-30thAnniversary.jpg": "ec7e",
	"./keyvisuals - Copy/assets/news/news_28-04-2021-XmasParty.jpg": "3a94",
	"./keyvisuals - Copy/assets/news/news_31-03-2021.jpg": "9a1a",
	"./keyvisuals - Copy/assets/news/news_bg_7-7-2021.jpg": "6871",
	"./keyvisuals - Copy/assets/news/representative_tokyo2020-08_08_2021.jpg": "6b55",
	"./keyvisuals - Copy/assets/news/tagaveritasako_7-9-2021.jpg": "49e7",
	"./keyvisuals - Copy/assets/news/weightlifting_07-28-2021.jpg": "ae76",
	"./keyvisuals - Copy/assets/news/weightlifting_orig_07-28-2021.jpg": "9aab",
	"./keyvisuals - Copy/assets/news_container.jpg": "9040",
	"./keyvisuals - Copy/assets/no_image.jpg": "6eba",
	"./keyvisuals - Copy/assets/one_crew_onboard.jpg": "4862",
	"./keyvisuals - Copy/assets/principals/fujitrans_logo.jpg": "682c",
	"./keyvisuals - Copy/assets/principals/kline_krbs_logo.jpg": "43a7",
	"./keyvisuals - Copy/assets/principals/sancho_kaiun_logo.jpg": "a7b6",
	"./keyvisuals - Copy/assets/profile-black.png": "a4b7",
	"./keyvisuals - Copy/assets/profile-white.png": "e296",
	"./keyvisuals - Copy/assets/programs/allottees/2015_bicol.jpg": "08b8",
	"./keyvisuals - Copy/assets/programs/allottees/2015_davao.jpg": "baaa",
	"./keyvisuals - Copy/assets/programs/allottees/2016_alloottees_bacolod.jpg": "27ca",
	"./keyvisuals - Copy/assets/programs/allottees/2016_alloottees_bohol.jpg": "3838",
	"./keyvisuals - Copy/assets/programs/allottees/2016_alloottees_cebu.jpg": "03fa",
	"./keyvisuals - Copy/assets/programs/allottees/2016_alloottees_gma.jpg": "e785",
	"./keyvisuals - Copy/assets/programs/allottees/2016_alloottees_iloilo.jpg": "39eb",
	"./keyvisuals - Copy/assets/programs/allottees/2017_bicol.jpg": "a54f",
	"./keyvisuals - Copy/assets/programs/allottees/2017_cdo.jpg": "1fd0",
	"./keyvisuals - Copy/assets/programs/allottees/2017_dvo.jpg": "8168",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bacolod/allottee1_7-8-2021.jpg": "3223",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bacolod/allottee2_7-8-2021.jpg": "8f00",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bacolod/allottee3_7-8-2021.jpg": "2872",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bicol/allottee1_7-8-2021.jpg": "85dc",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bicol/allottee2_7-8-2021.jpg": "b57a",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bicol/allottee3_7-8-2021.jpg": "d52e",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bohol/allottee1_7-8-2021.jpg": "e558",
	"./keyvisuals - Copy/assets/programs/allottees/2018/bohol/allottee2_7-8-2021.jpg": "f5ec",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cdo/allottee1_7-8-2021.jpg": "a4ce",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cdo/allottee2_7-8-2021.jpg": "5e9d",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cdo/allottee3_7-8-2021.jpg": "cbb4",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cebu/allottee1_7-8-2021.jpg": "51a5",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cebu/allottee2_7-8-2021.jpg": "48a0",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cebu/allottee3_7-8-2021.jpg": "dccf",
	"./keyvisuals - Copy/assets/programs/allottees/2018/cebu/allottee4_7-8-2021.jpg": "d35c",
	"./keyvisuals - Copy/assets/programs/allottees/2018/davao/allottee1_7-8-2021.jpg": "51f5",
	"./keyvisuals - Copy/assets/programs/allottees/2018/davao/allottee2_7-8-2021.jpg": "c9f0",
	"./keyvisuals - Copy/assets/programs/allottees/2018/davao/allottee3_7-8-2021.jpg": "78ca",
	"./keyvisuals - Copy/assets/programs/allottees/2018/iloilo/allottee1_7-8-2021.jpg": "a0f3",
	"./keyvisuals - Copy/assets/programs/allottees/2018/iloilo/allottee2_7-8-2021.jpg": "b55b",
	"./keyvisuals - Copy/assets/programs/allottees/2018/iloilo/allottee3_7-8-2021.jpg": "3033",
	"./keyvisuals - Copy/assets/programs/allottees/2018/iloilo/allottee4_7-8-2021.jpg": "e9dc",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bacolod/allottee1_7-8-2021.jpg": "8fd1",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bacolod/allottee2_7-8-2021.jpg": "3f86",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bacolod/allottee3_7-8-2021.jpg": "7b8f",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bohol/allottee1_7-8-2021.jpg": "ebf0",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bohol/allottee2_7-8-2021.jpg": "b4ab",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bohol/allottee3_7-8-2021.jpg": "fe80",
	"./keyvisuals - Copy/assets/programs/allottees/2019/bohol/allottee4_7-8-2021.jpg": "b8db",
	"./keyvisuals - Copy/assets/programs/allottees/2019/cebu/allottee1_7-8-2021.jpg": "b74d",
	"./keyvisuals - Copy/assets/programs/allottees/2019/cebu/allottee2_7-8-2021.jpg": "083e",
	"./keyvisuals - Copy/assets/programs/allottees/2019/cebu/allottee3_7-8-2021.jpg": "3293",
	"./keyvisuals - Copy/assets/programs/allottees/2019/davao/allottee1_7-8-2021.jpg": "3255",
	"./keyvisuals - Copy/assets/programs/allottees/2019/davao/allottee2_7-8-2021.jpg": "3586",
	"./keyvisuals - Copy/assets/programs/allottees/2019/davao/allottee3_7-8-2021.jpg": "6455",
	"./keyvisuals - Copy/assets/programs/allottees/2019/davao/allottee4_7-8-2021.jpg": "09bc",
	"./keyvisuals - Copy/assets/programs/allottees/2019/iloilo/allottee1_7-8-2021.jpg": "bf7a",
	"./keyvisuals - Copy/assets/programs/allottees/2019/iloilo/allottee2_7-8-2021.jpg": "530d",
	"./keyvisuals - Copy/assets/programs/allottees/2019/iloilo/allottee3_7-8-2021.jpg": "7f53",
	"./keyvisuals - Copy/assets/programs/allottees/2019/iloilo/allottee4_7-8-2021.jpg": "209f",
	"./keyvisuals - Copy/assets/programs/allottees/2019/manila/allottee1_7-8-2021.jpg": "634c",
	"./keyvisuals - Copy/assets/programs/allottees/2019/manila/allottee2_7-8-2021.jpg": "0e8e",
	"./keyvisuals - Copy/assets/programs/allottees/2019/manila/allottee3_7-8-2021.jpg": "fbe5",
	"./keyvisuals - Copy/assets/programs/allottees/2019/manila/allottee4_7-8-2021.jpg": "edb4",
	"./keyvisuals - Copy/assets/programs/allottees/2019/manila/allottee5_7-8-2021.jpg": "e319",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_a_70121.jpg": "04b7",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_b_70121.jpg": "f24c",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_c_70121.jpg": "ed4e",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_d_70121.jpg": "42bd",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_e_70121.jpg": "5c81",
	"./keyvisuals - Copy/assets/programs/allottees/2020/all_f_70121.jpg": "ae49",
	"./keyvisuals - Copy/assets/programs/allottees/2020/iloilo_a_70121.jpg": "6550",
	"./keyvisuals - Copy/assets/programs/allottees/2020/iloilo_b_70121.jpg": "9871",
	"./keyvisuals - Copy/assets/programs/allottees/2020/iloilo_c_70121.jpg": "87e8",
	"./keyvisuals - Copy/assets/programs/allottees/2021/2021AlloteeVisayasTiktok.jpg": "6740",
	"./keyvisuals - Copy/assets/programs/allottees/2021/2021AllotteeOthers.jpg": "4c6d",
	"./keyvisuals - Copy/assets/ship404.png": "f5f9",
	"./keyvisuals - Copy/assets/veritas_logo.png": "7b14",
	"./keyvisuals - Copy/assets/veritas_pin.jpg": "6c2e",
	"./keyvisuals - Copy/assets/veritas_pin_covid19.jpg": "07d1",
	"./keyvisuals - Copy/assets/vessel_cape_sasanqua.jpg": "f006",
	"./keyvisuals - Copy/assets/vessel_corona_citrus.jpg": "439e",
	"./keyvisuals - Copy/assets/vessel_drive_green.jpg": "4ccd",
	"./keyvisuals - Copy/assets/vessel_floor.jpg": "30b3",
	"./keyvisuals - Copy/assets/vessel_kline_wide.jpg": "a9c1",
	"./keyvisuals - Copy/assets/vessel_new_century.jpg": "f033",
	"./keyvisuals - Copy/banner1.jpg": "4360",
	"./keyvisuals - Copy/banner2_0.jpg": "bdd7",
	"./keyvisuals - Copy/banner3_0.jpg": "730f",
	"./keyvisuals - Copy/capebrolga_92921.jpg": "54dd",
	"./keyvisuals - Copy/capehayate_032024KV.jpg": "b0ab",
	"./keyvisuals - Copy/capenormandy_053022KV.jpg": "4a78",
	"./keyvisuals - Copy/coronamajesty_053022KV.jpg": "8691",
	"./keyvisuals - Copy/covidCaseSep26toOct2-2022KV.jpg": "c9c8",
	"./keyvisuals - Copy/covid_cases_071122KV.jpg": "25c9",
	"./keyvisuals - Copy/covid_cases_27522KV.jpg": "b1e3",
	"./keyvisuals - Copy/intlSeafarer_62722KV.jpg": "3e27",
	"./keyvisuals - Copy/mlcisocert_52022KV.jpg": "4b9b",
	"./keyvisuals - Copy/retirees_63021.jpg": "1bf9",
	"./keyvisuals/BicolAllottee2025.jpg": "6346",
	"./keyvisuals/KRBS 4mb.mp4": "e036",
	"./keyvisuals/KRBS 6mb.mp4": "5d5d",
	"./keyvisuals/Taga_Veritas_Ako_63021.jpg": "ca41",
	"./keyvisuals/VIJAYANAGAR.jpg": "b43b",
	"./keyvisuals/VeritasFront-Liners_7-12-2019.jpg": "26c6",
	"./keyvisuals/assets/about/30Years.jpg": "ed63",
	"./keyvisuals/assets/about/Marc2000tower.jpg": "13d9",
	"./keyvisuals/assets/about/VMCTopManagement.jpg": "bcea",
	"./keyvisuals/assets/about/allvmcorgchart.jpg": "bba2",
	"./keyvisuals/assets/about/quality_crew_7-7-2021.jpg": "c099",
	"./keyvisuals/assets/about/topmgmtchart.jpg": "0a0d",
	"./keyvisuals/assets/about/vmc_office_logo-7-7-2021.jpg": "a4f8",
	"./keyvisuals/assets/affiliates/govlogo/ched.jpg": "2572",
	"./keyvisuals/assets/affiliates/govlogo/deped.jpg": "10a4",
	"./keyvisuals/assets/affiliates/govlogo/dfa.jpg": "221a",
	"./keyvisuals/assets/affiliates/govlogo/dole.jpg": "3130",
	"./keyvisuals/assets/affiliates/govlogo/dotr.jpg": "dada",
	"./keyvisuals/assets/affiliates/govlogo/pcg.jpg": "f82c",
	"./keyvisuals/assets/affiliates/govlogo/pdea.jpg": "c88d",
	"./keyvisuals/assets/affiliates/govlogo/pmma.jpg": "547a",
	"./keyvisuals/assets/affiliates/govlogo/ppa.jpg": "16bf",
	"./keyvisuals/assets/affiliates/iso_9001.jpg": "a5ad",
	"./keyvisuals/assets/affiliates/iso_9001_dnv.jpg": "6ba6",
	"./keyvisuals/assets/affiliates/klma.jpg": "49e8",
	"./keyvisuals/assets/affiliates/marina.jpg": "e29c",
	"./keyvisuals/assets/affiliates/pamas.jpg": "85a0",
	"./keyvisuals/assets/affiliates/pdos.jpg": "025b",
	"./keyvisuals/assets/affiliates/pjmcc.jpg": "68a3",
	"./keyvisuals/assets/affiliates/prc.jpg": "3a7f",
	"./keyvisuals/assets/affiliates/ukas.jpg": "78cb",
	"./keyvisuals/assets/blue_background.jpg": "6dc6",
	"./keyvisuals/assets/car_group.jpg": "68c0",
	"./keyvisuals/assets/careers/2025/vmcHiring_03062025.jpg": "8859",
	"./keyvisuals/assets/careers/2025/vmcHiring_04222025.jpg": "04ee",
	"./keyvisuals/assets/careers/career_bg.jpg": "f718",
	"./keyvisuals/assets/contactus/contact_us_bg.jpg": "6eee",
	"./keyvisuals/assets/crew_group.jpg": "df66",
	"./keyvisuals/assets/crew_onboarding.jpg": "ae8c",
	"./keyvisuals/assets/crew_onboarding_short.jpg": "0463",
	"./keyvisuals/assets/crews/cadet_7-7-2021.jpg": "85d9",
	"./keyvisuals/assets/crews/cadet_schooluniform_7-7-2021.jpg": "fc7e",
	"./keyvisuals/assets/crews/cook_7-7-2021.jpg": "002b",
	"./keyvisuals/assets/crews/crew_group.jpg": "e9cc",
	"./keyvisuals/assets/crews/crew_upgrade1_7-7-2021.jpg": "1324",
	"./keyvisuals/assets/crews/crew_upgrade2_7-7-2021.jpg": "b0af",
	"./keyvisuals/assets/crews/crew_upgrade3_7-7-2021.jpg": "c04e4",
	"./keyvisuals/assets/crews/crew_upgrade4_7-7-2021.jpg": "de48",
	"./keyvisuals/assets/crews/fastTrackCadetTraining.jpg": "15f6",
	"./keyvisuals/assets/crews/inhouseSeminar1.jpg": "ae2a",
	"./keyvisuals/assets/crews/inhouseSeminar2.jpg": "c539",
	"./keyvisuals/assets/crews/me1.jpg": "d8a3",
	"./keyvisuals/assets/crews/me2.jpg": "0226",
	"./keyvisuals/assets/crews/me3.jpg": "c8ee",
	"./keyvisuals/assets/crews/otherInHouse1.jpg": "28c8",
	"./keyvisuals/assets/crews/otherInHouse2.jpg": "b5aa",
	"./keyvisuals/assets/crews/pre-cadetshipTraining.jpg": "3f0a",
	"./keyvisuals/assets/crews/promotionTraining1.jpg": "67ec",
	"./keyvisuals/assets/crews/rating1_7-7-2021.jpg": "3b6d",
	"./keyvisuals/assets/crews/rating2_7-7-2021.jpg": "268d",
	"./keyvisuals/assets/crews/scholarshipTraining.jpg": "3084",
	"./keyvisuals/assets/crews/shipboardTraining.jpg": "f72d",
	"./keyvisuals/assets/fabric-texture.png": "139c",
	"./keyvisuals/assets/keyvisuals/BicolAllottee2025.jpg": "cbbf",
	"./keyvisuals/assets/keyvisuals/KRBS 4mb.mp4": "78eb9",
	"./keyvisuals/assets/keyvisuals/KRBS 6mb.mp4": "59c3",
	"./keyvisuals/assets/keyvisuals/Taga_Veritas_Ako_63021.jpg": "d575",
	"./keyvisuals/assets/keyvisuals/VIJAYANAGAR.jpg": "2a5e",
	"./keyvisuals/assets/keyvisuals/VeritasFront-Liners_7-12-2019.jpg": "676c",
	"./keyvisuals/assets/keyvisuals/banner1.jpg": "80bd",
	"./keyvisuals/assets/keyvisuals/banner2_0.jpg": "7466",
	"./keyvisuals/assets/keyvisuals/banner3_0.jpg": "fd07",
	"./keyvisuals/assets/keyvisuals/capebrolga_92921.jpg": "c6d3",
	"./keyvisuals/assets/keyvisuals/capehayate_032024KV.jpg": "0ccd",
	"./keyvisuals/assets/keyvisuals/capenormandy_053022KV.jpg": "7d8d",
	"./keyvisuals/assets/keyvisuals/coronamajesty_053022KV.jpg": "3733",
	"./keyvisuals/assets/keyvisuals/covidCaseSep26toOct2-2022KV.jpg": "df3a",
	"./keyvisuals/assets/keyvisuals/covid_cases_071122KV.jpg": "0261",
	"./keyvisuals/assets/keyvisuals/covid_cases_27522KV.jpg": "b50f",
	"./keyvisuals/assets/keyvisuals/intlSeafarer_62722KV.jpg": "efd9",
	"./keyvisuals/assets/keyvisuals/mlcisocert_52022KV.jpg": "e5f1",
	"./keyvisuals/assets/keyvisuals/retirees_63021.jpg": "82bd",
	"./keyvisuals/assets/news/2014E015_covid_7-6-2021.jpg": "7b36",
	"./keyvisuals/assets/news/2020/joiningcrew/crew1_7-8-2021.jpg": "d2ab",
	"./keyvisuals/assets/news/2020/joiningcrew/crew2_7-8-2021.jpg": "2d8c",
	"./keyvisuals/assets/news/2020/joiningcrew/crew3_7-8-2021.jpg": "7570",
	"./keyvisuals/assets/news/2020/joiningcrew/crew4_7-8-2021.jpg": "ba80",
	"./keyvisuals/assets/news/2020/joiningcrew/crew5_7-8-2021.jpg": "a9ab",
	"./keyvisuals/assets/news/2020/newnormaloffice/office1_7-8-2021.jpg": "53b6",
	"./keyvisuals/assets/news/2020/newnormaloffice/office2_7-8-2021.jpg": "a93a",
	"./keyvisuals/assets/news/2020/newnormaloffice/office3_7-8-2021.jpg": "90a7",
	"./keyvisuals/assets/news/2020/newnormaloffice/office4_7-8-2021.jpg": "5d08",
	"./keyvisuals/assets/news/2020/newnormaloffice/office5_7-8-2021.jpg": "651b",
	"./keyvisuals/assets/news/2020/newnormaloffice/office6_7-8-2021.jpg": "2d15",
	"./keyvisuals/assets/news/2020/newnormaloffice/office7_7-8-2021.jpg": "bc2f",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect1_7-8-2021.jpg": "9e07",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect2_7-8-2021.jpg": "fd74",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect3_7-8-2021.jpg": "c819",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect4_7-8-2021.jpg": "fb2b",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect5_7-8-2021.jpg": "0d70",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect6_7-8-2021.jpg": "04ed",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect7_7-8-2021.jpg": "9e23",
	"./keyvisuals/assets/news/2020/tnkcinspection/boqinspect8_7-8-2021.jpg": "2a7f",
	"./keyvisuals/assets/news/2020/tnkcswabtest/swab1_7-8-2021.jpg": "d875",
	"./keyvisuals/assets/news/2020/tnkcswabtest/swab2_7-8-2021.jpg": "13e7",
	"./keyvisuals/assets/news/2020/tnkcswabtest/swab3_7-8-2021.jpg": "ac81",
	"./keyvisuals/assets/news/2021/mis_news_111221.jpg": "85b9",
	"./keyvisuals/assets/news/2021/vaccinesched/area1_061221.jpg": "9224",
	"./keyvisuals/assets/news/2021/vaccinesched/area1_211021.jpg": "7f94",
	"./keyvisuals/assets/news/2021/vaccinesched/area1_thumbnail_061221.jpg": "f757",
	"./keyvisuals/assets/news/2021/vaccinesched/area2_211021.jpg": "0898",
	"./keyvisuals/assets/news/2021/vaccinesched/area3_211021.jpg": "c146",
	"./keyvisuals/assets/news/2021/vaccinesched/area4_211021.jpg": "c4e0",
	"./keyvisuals/assets/news/2021/vaccinesched/area5_211021.jpg": "c5b5",
	"./keyvisuals/assets/news/2021/vaccinesched/area6_211021.jpg": "e6c7",
	"./keyvisuals/assets/news/2021/vaccinesched/area7_211021.jpg": "3bb9",
	"./keyvisuals/assets/news/2021/vaccinesched/area8_211021.jpg": "96e8",
	"./keyvisuals/assets/news/2021/vaccinesched/area_thumbnail_211021.jpg": "bdb1",
	"./keyvisuals/assets/news/2022/jul/33rd_anniversary_0714-A.jpg": "2d75",
	"./keyvisuals/assets/news/2022/jul/33rd_anniversary_0714-B.jpg": "17f0",
	"./keyvisuals/assets/news/2022/jul/33rd_anniversary_0714-C.jpg": "5440",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture1.jpg": "6304",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture10.jpg": "f033c",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture11.jpg": "9be4",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture12.jpg": "9023",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture13.jpg": "12c3",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture14.jpg": "ec54",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture15.jpg": "2e32",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture16.jpg": "47f0",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture17.jpg": "9069",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture18.jpg": "08c7",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture19.jpg": "5343",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture2.jpg": "a6e5",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture3.jpg": "9f16",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture4.jpg": "be96",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture5.jpg": "6c68",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture6.jpg": "754a",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture7.jpg": "72dc",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture8.jpg": "f3d7",
	"./keyvisuals/assets/news/2022/jul/VoyageLifetimeHeritage/Picture9.jpg": "83ce",
	"./keyvisuals/assets/news/2022/jul/covidCaseJul11to17-2022.jpg": "95e8",
	"./keyvisuals/assets/news/2022/jul/covidCaseJul11to17-2022KV.jpg": "b77c",
	"./keyvisuals/assets/news/2022/may/Picture1.jpg": "b33f",
	"./keyvisuals/assets/news/2022/may/Picture10.jpg": "61c5",
	"./keyvisuals/assets/news/2022/may/Picture11.jpg": "069d",
	"./keyvisuals/assets/news/2022/may/Picture12.jpg": "a679",
	"./keyvisuals/assets/news/2022/may/Picture13.jpg": "5cee",
	"./keyvisuals/assets/news/2022/may/Picture14.jpg": "353e",
	"./keyvisuals/assets/news/2022/may/Picture15.jpg": "c59f",
	"./keyvisuals/assets/news/2022/may/Picture2.jpg": "35d6",
	"./keyvisuals/assets/news/2022/may/Picture3.jpg": "eb49",
	"./keyvisuals/assets/news/2022/may/Picture4.jpg": "3aa4",
	"./keyvisuals/assets/news/2022/may/Picture5.jpg": "d82c",
	"./keyvisuals/assets/news/2022/may/Picture6.jpg": "cbaa",
	"./keyvisuals/assets/news/2022/may/Picture7.jpg": "51b1",
	"./keyvisuals/assets/news/2022/may/Picture8.jpg": "4815",
	"./keyvisuals/assets/news/2022/may/Picture9.jpg": "38ae",
	"./keyvisuals/assets/news/2022/may/covid_cases_27522.jpg": "7ddc",
	"./keyvisuals/assets/news/2022/may/covid_cases_27522R.jpg": "72a1",
	"./keyvisuals/assets/news/2022/may/mlcisocert_52022-thumbnail.jpg": "62b3",
	"./keyvisuals/assets/news/2022/may/mlcisocert_52022.jpg": "9324",
	"./keyvisuals/assets/news/2022WomanLikeNoOther.jpg": "242b",
	"./keyvisuals/assets/news/2023/CrewFamilyXmas.png": "5426",
	"./keyvisuals/assets/news/2023/StaffXmasParty.png": "27bc",
	"./keyvisuals/assets/news/2024/CebuBohol2024.jpg": "a380",
	"./keyvisuals/assets/news/2024/IloiloBacolod2024.jpg": "22fd",
	"./keyvisuals/assets/news/2024/anniversary/Anniversary35A.jpg": "2ce1",
	"./keyvisuals/assets/news/2024/anniversary/Anniversary35A.png": "02d6",
	"./keyvisuals/assets/news/2024/anniversary/Anniversary35B.png": "dd1a",
	"./keyvisuals/assets/news/2024/anniversary/Anniversary35C.png": "3f43",
	"./keyvisuals/assets/news/2024/anniversary/Anniversary35D.png": "bf5e",
	"./keyvisuals/assets/news/SeafarersHeroesOfPandemic2_7-9-2021.jpg": "cfcb",
	"./keyvisuals/assets/news/SeafarersHeroesOfPandemic_7-9-2021.jpg": "36c9",
	"./keyvisuals/assets/news/SeafarersHeroes_home.jpg": "161c",
	"./keyvisuals/assets/news/TeodoroLocsinMessage25June2021.jpg": "1ea3",
	"./keyvisuals/assets/news/TeodoroLocsinMessage_home.jpg": "40a1",
	"./keyvisuals/assets/news/govt_advisory_template.jpg": "3526",
	"./keyvisuals/assets/news/medalist_cv_tokyo2020-08_08_2021.jpg": "de58",
	"./keyvisuals/assets/news/medalist_tokyo2020-08_08_2021.jpg": "3a71",
	"./keyvisuals/assets/news/newsStaff_7-10-2021.jpg": "29dd",
	"./keyvisuals/assets/news/news_10-03-2021.jpg": "20bf",
	"./keyvisuals/assets/news/news_17-06-2019.jpg": "6a49",
	"./keyvisuals/assets/news/news_28-04-2021-30thAnniversary.jpg": "0287",
	"./keyvisuals/assets/news/news_28-04-2021-XmasParty.jpg": "554e",
	"./keyvisuals/assets/news/news_31-03-2021.jpg": "8fbf",
	"./keyvisuals/assets/news/news_bg_7-7-2021.jpg": "ec1a",
	"./keyvisuals/assets/news/representative_tokyo2020-08_08_2021.jpg": "d7c2",
	"./keyvisuals/assets/news/tagaveritasako_7-9-2021.jpg": "c5f5",
	"./keyvisuals/assets/news/weightlifting_07-28-2021.jpg": "b755",
	"./keyvisuals/assets/news/weightlifting_orig_07-28-2021.jpg": "8193",
	"./keyvisuals/assets/news_container.jpg": "e7ff",
	"./keyvisuals/assets/no_image.jpg": "314d",
	"./keyvisuals/assets/one_crew_onboard.jpg": "166fe",
	"./keyvisuals/assets/principals/fujitrans_logo.jpg": "b99e",
	"./keyvisuals/assets/principals/kline_krbs_logo.jpg": "cefd",
	"./keyvisuals/assets/principals/sancho_kaiun_logo.jpg": "59d9",
	"./keyvisuals/assets/profile-black.png": "80d4",
	"./keyvisuals/assets/profile-white.png": "6ebd",
	"./keyvisuals/assets/programs/allottees/2015_bicol.jpg": "7325",
	"./keyvisuals/assets/programs/allottees/2015_davao.jpg": "f889",
	"./keyvisuals/assets/programs/allottees/2016_alloottees_bacolod.jpg": "7b79",
	"./keyvisuals/assets/programs/allottees/2016_alloottees_bohol.jpg": "210e",
	"./keyvisuals/assets/programs/allottees/2016_alloottees_cebu.jpg": "db65",
	"./keyvisuals/assets/programs/allottees/2016_alloottees_gma.jpg": "4110",
	"./keyvisuals/assets/programs/allottees/2016_alloottees_iloilo.jpg": "1969",
	"./keyvisuals/assets/programs/allottees/2017_bicol.jpg": "0df3",
	"./keyvisuals/assets/programs/allottees/2017_cdo.jpg": "2a5e1",
	"./keyvisuals/assets/programs/allottees/2017_dvo.jpg": "6a22",
	"./keyvisuals/assets/programs/allottees/2018/bacolod/allottee1_7-8-2021.jpg": "cc6d",
	"./keyvisuals/assets/programs/allottees/2018/bacolod/allottee2_7-8-2021.jpg": "ded8",
	"./keyvisuals/assets/programs/allottees/2018/bacolod/allottee3_7-8-2021.jpg": "fbf5",
	"./keyvisuals/assets/programs/allottees/2018/bicol/allottee1_7-8-2021.jpg": "87db",
	"./keyvisuals/assets/programs/allottees/2018/bicol/allottee2_7-8-2021.jpg": "3c00",
	"./keyvisuals/assets/programs/allottees/2018/bicol/allottee3_7-8-2021.jpg": "0cf6",
	"./keyvisuals/assets/programs/allottees/2018/bohol/allottee1_7-8-2021.jpg": "ed44",
	"./keyvisuals/assets/programs/allottees/2018/bohol/allottee2_7-8-2021.jpg": "e007",
	"./keyvisuals/assets/programs/allottees/2018/cdo/allottee1_7-8-2021.jpg": "ccde",
	"./keyvisuals/assets/programs/allottees/2018/cdo/allottee2_7-8-2021.jpg": "7d7a",
	"./keyvisuals/assets/programs/allottees/2018/cdo/allottee3_7-8-2021.jpg": "d0b2",
	"./keyvisuals/assets/programs/allottees/2018/cebu/allottee1_7-8-2021.jpg": "0e5f",
	"./keyvisuals/assets/programs/allottees/2018/cebu/allottee2_7-8-2021.jpg": "32ff",
	"./keyvisuals/assets/programs/allottees/2018/cebu/allottee3_7-8-2021.jpg": "5351",
	"./keyvisuals/assets/programs/allottees/2018/cebu/allottee4_7-8-2021.jpg": "ae60",
	"./keyvisuals/assets/programs/allottees/2018/davao/allottee1_7-8-2021.jpg": "0ded",
	"./keyvisuals/assets/programs/allottees/2018/davao/allottee2_7-8-2021.jpg": "fbbb",
	"./keyvisuals/assets/programs/allottees/2018/davao/allottee3_7-8-2021.jpg": "4642",
	"./keyvisuals/assets/programs/allottees/2018/iloilo/allottee1_7-8-2021.jpg": "877f",
	"./keyvisuals/assets/programs/allottees/2018/iloilo/allottee2_7-8-2021.jpg": "3125",
	"./keyvisuals/assets/programs/allottees/2018/iloilo/allottee3_7-8-2021.jpg": "5cca",
	"./keyvisuals/assets/programs/allottees/2018/iloilo/allottee4_7-8-2021.jpg": "a32b",
	"./keyvisuals/assets/programs/allottees/2019/bacolod/allottee1_7-8-2021.jpg": "b3d4",
	"./keyvisuals/assets/programs/allottees/2019/bacolod/allottee2_7-8-2021.jpg": "a29c",
	"./keyvisuals/assets/programs/allottees/2019/bacolod/allottee3_7-8-2021.jpg": "f7fa",
	"./keyvisuals/assets/programs/allottees/2019/bohol/allottee1_7-8-2021.jpg": "a2ab",
	"./keyvisuals/assets/programs/allottees/2019/bohol/allottee2_7-8-2021.jpg": "afdb",
	"./keyvisuals/assets/programs/allottees/2019/bohol/allottee3_7-8-2021.jpg": "d2a6",
	"./keyvisuals/assets/programs/allottees/2019/bohol/allottee4_7-8-2021.jpg": "35af",
	"./keyvisuals/assets/programs/allottees/2019/cebu/allottee1_7-8-2021.jpg": "584d",
	"./keyvisuals/assets/programs/allottees/2019/cebu/allottee2_7-8-2021.jpg": "cfba",
	"./keyvisuals/assets/programs/allottees/2019/cebu/allottee3_7-8-2021.jpg": "98ff",
	"./keyvisuals/assets/programs/allottees/2019/davao/allottee1_7-8-2021.jpg": "a0cc",
	"./keyvisuals/assets/programs/allottees/2019/davao/allottee2_7-8-2021.jpg": "817e",
	"./keyvisuals/assets/programs/allottees/2019/davao/allottee3_7-8-2021.jpg": "f6e0",
	"./keyvisuals/assets/programs/allottees/2019/davao/allottee4_7-8-2021.jpg": "b2a6",
	"./keyvisuals/assets/programs/allottees/2019/iloilo/allottee1_7-8-2021.jpg": "177c",
	"./keyvisuals/assets/programs/allottees/2019/iloilo/allottee2_7-8-2021.jpg": "da6a",
	"./keyvisuals/assets/programs/allottees/2019/iloilo/allottee3_7-8-2021.jpg": "dc18",
	"./keyvisuals/assets/programs/allottees/2019/iloilo/allottee4_7-8-2021.jpg": "430c",
	"./keyvisuals/assets/programs/allottees/2019/manila/allottee1_7-8-2021.jpg": "a077",
	"./keyvisuals/assets/programs/allottees/2019/manila/allottee2_7-8-2021.jpg": "745e",
	"./keyvisuals/assets/programs/allottees/2019/manila/allottee3_7-8-2021.jpg": "658c",
	"./keyvisuals/assets/programs/allottees/2019/manila/allottee4_7-8-2021.jpg": "122c",
	"./keyvisuals/assets/programs/allottees/2019/manila/allottee5_7-8-2021.jpg": "c0c6",
	"./keyvisuals/assets/programs/allottees/2020/all_a_70121.jpg": "0a52",
	"./keyvisuals/assets/programs/allottees/2020/all_b_70121.jpg": "da6f0",
	"./keyvisuals/assets/programs/allottees/2020/all_c_70121.jpg": "4f78",
	"./keyvisuals/assets/programs/allottees/2020/all_d_70121.jpg": "7c27",
	"./keyvisuals/assets/programs/allottees/2020/all_e_70121.jpg": "038e",
	"./keyvisuals/assets/programs/allottees/2020/all_f_70121.jpg": "1800",
	"./keyvisuals/assets/programs/allottees/2020/iloilo_a_70121.jpg": "f3fa",
	"./keyvisuals/assets/programs/allottees/2020/iloilo_b_70121.jpg": "12b9",
	"./keyvisuals/assets/programs/allottees/2020/iloilo_c_70121.jpg": "1d3a",
	"./keyvisuals/assets/programs/allottees/2021/2021AlloteeVisayasTiktok.jpg": "4073",
	"./keyvisuals/assets/programs/allottees/2021/2021AllotteeOthers.jpg": "5a3e",
	"./keyvisuals/assets/ship404.png": "50dd",
	"./keyvisuals/assets/veritas_logo.png": "53e6",
	"./keyvisuals/assets/veritas_pin.jpg": "5acc",
	"./keyvisuals/assets/veritas_pin_covid19.jpg": "a336",
	"./keyvisuals/assets/vessel_cape_sasanqua.jpg": "04e8",
	"./keyvisuals/assets/vessel_corona_citrus.jpg": "ec39",
	"./keyvisuals/assets/vessel_drive_green.jpg": "7dcd",
	"./keyvisuals/assets/vessel_floor.jpg": "6011",
	"./keyvisuals/assets/vessel_kline_wide.jpg": "b787",
	"./keyvisuals/assets/vessel_new_century.jpg": "ee37",
	"./keyvisuals/banner1.jpg": "a070",
	"./keyvisuals/banner2_0.jpg": "2236",
	"./keyvisuals/banner3_0.jpg": "3514",
	"./keyvisuals/capebrolga_92921.jpg": "b070",
	"./keyvisuals/capehayate_032024KV.jpg": "9a75",
	"./keyvisuals/capenormandy_053022KV.jpg": "ffb1",
	"./keyvisuals/coronamajesty_053022KV.jpg": "5da9",
	"./keyvisuals/covidCaseSep26toOct2-2022KV.jpg": "4c24",
	"./keyvisuals/covid_cases_071122KV.jpg": "fc07",
	"./keyvisuals/covid_cases_27522KV.jpg": "4899",
	"./keyvisuals/intlSeafarer_62722KV.jpg": "3dca",
	"./keyvisuals/mlcisocert_52022KV.jpg": "805c",
	"./keyvisuals/retirees_63021.jpg": "e8a2",
	"./news/2014E015_covid_7-6-2021.jpg": "d98f",
	"./news/2020/joiningcrew/crew1_7-8-2021.jpg": "ab2d",
	"./news/2020/joiningcrew/crew2_7-8-2021.jpg": "1993",
	"./news/2020/joiningcrew/crew3_7-8-2021.jpg": "5e4d",
	"./news/2020/joiningcrew/crew4_7-8-2021.jpg": "a1bf",
	"./news/2020/joiningcrew/crew5_7-8-2021.jpg": "d241",
	"./news/2020/newnormaloffice/office1_7-8-2021.jpg": "4907",
	"./news/2020/newnormaloffice/office2_7-8-2021.jpg": "c22f",
	"./news/2020/newnormaloffice/office3_7-8-2021.jpg": "a111",
	"./news/2020/newnormaloffice/office4_7-8-2021.jpg": "b38a",
	"./news/2020/newnormaloffice/office5_7-8-2021.jpg": "3536",
	"./news/2020/newnormaloffice/office6_7-8-2021.jpg": "0fb0",
	"./news/2020/newnormaloffice/office7_7-8-2021.jpg": "01e6",
	"./news/2020/tnkcinspection/boqinspect1_7-8-2021.jpg": "c8e2",
	"./news/2020/tnkcinspection/boqinspect2_7-8-2021.jpg": "ae56",
	"./news/2020/tnkcinspection/boqinspect3_7-8-2021.jpg": "74a4",
	"./news/2020/tnkcinspection/boqinspect4_7-8-2021.jpg": "a7a7",
	"./news/2020/tnkcinspection/boqinspect5_7-8-2021.jpg": "b4c3",
	"./news/2020/tnkcinspection/boqinspect6_7-8-2021.jpg": "8b37",
	"./news/2020/tnkcinspection/boqinspect7_7-8-2021.jpg": "00bb",
	"./news/2020/tnkcinspection/boqinspect8_7-8-2021.jpg": "d315",
	"./news/2020/tnkcswabtest/swab1_7-8-2021.jpg": "70a1",
	"./news/2020/tnkcswabtest/swab2_7-8-2021.jpg": "5b86",
	"./news/2020/tnkcswabtest/swab3_7-8-2021.jpg": "fd0a",
	"./news/2021/mis_news_111221.jpg": "3ea9",
	"./news/2021/vaccinesched/area1_061221.jpg": "13be",
	"./news/2021/vaccinesched/area1_211021.jpg": "1060",
	"./news/2021/vaccinesched/area1_thumbnail_061221.jpg": "5347",
	"./news/2021/vaccinesched/area2_211021.jpg": "8469",
	"./news/2021/vaccinesched/area3_211021.jpg": "5136",
	"./news/2021/vaccinesched/area4_211021.jpg": "a3b3",
	"./news/2021/vaccinesched/area5_211021.jpg": "8dd0",
	"./news/2021/vaccinesched/area6_211021.jpg": "4f47",
	"./news/2021/vaccinesched/area7_211021.jpg": "53f6",
	"./news/2021/vaccinesched/area8_211021.jpg": "3964",
	"./news/2021/vaccinesched/area_thumbnail_211021.jpg": "7eb9",
	"./news/2022/jul/33rd_anniversary_0714-A.jpg": "4fc9",
	"./news/2022/jul/33rd_anniversary_0714-B.jpg": "7cb0",
	"./news/2022/jul/33rd_anniversary_0714-C.jpg": "55ba",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture1.jpg": "fc45",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture10.jpg": "a3bc",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture11.jpg": "1d7f",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture12.jpg": "a870",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture13.jpg": "8aa8",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture14.jpg": "8f1a",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture15.jpg": "b1db",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture16.jpg": "213b",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture17.jpg": "cc05",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture18.jpg": "3c56",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture19.jpg": "096d",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture2.jpg": "ed2a",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture3.jpg": "448e",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture4.jpg": "791a",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture5.jpg": "5927",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture6.jpg": "6fb5",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture7.jpg": "e7fd",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture8.jpg": "e410",
	"./news/2022/jul/VoyageLifetimeHeritage/Picture9.jpg": "4557",
	"./news/2022/jul/covidCaseJul11to17-2022.jpg": "24ad",
	"./news/2022/jul/covidCaseJul11to17-2022KV.jpg": "1c7a",
	"./news/2022/may/Picture1.jpg": "4212",
	"./news/2022/may/Picture10.jpg": "1411",
	"./news/2022/may/Picture11.jpg": "c93c",
	"./news/2022/may/Picture12.jpg": "fe55",
	"./news/2022/may/Picture13.jpg": "99ab",
	"./news/2022/may/Picture14.jpg": "bf61",
	"./news/2022/may/Picture15.jpg": "7717",
	"./news/2022/may/Picture2.jpg": "fdc1",
	"./news/2022/may/Picture3.jpg": "1f98",
	"./news/2022/may/Picture4.jpg": "6f39",
	"./news/2022/may/Picture5.jpg": "b14f",
	"./news/2022/may/Picture6.jpg": "4bd0",
	"./news/2022/may/Picture7.jpg": "a9af",
	"./news/2022/may/Picture8.jpg": "5bb2",
	"./news/2022/may/Picture9.jpg": "1795",
	"./news/2022/may/covid_cases_27522.jpg": "860c",
	"./news/2022/may/covid_cases_27522R.jpg": "4714",
	"./news/2022/may/mlcisocert_52022-thumbnail.jpg": "5d24",
	"./news/2022/may/mlcisocert_52022.jpg": "7e09",
	"./news/2022WomanLikeNoOther.jpg": "cddd",
	"./news/2023/CrewFamilyXmas.png": "e21c",
	"./news/2023/StaffXmasParty.png": "392a",
	"./news/2024/CebuBohol2024.jpg": "bdee",
	"./news/2024/IloiloBacolod2024.jpg": "96be",
	"./news/2024/anniversary/Anniversary35A.jpg": "7642",
	"./news/2024/anniversary/Anniversary35A.png": "992b",
	"./news/2024/anniversary/Anniversary35B.png": "69f6",
	"./news/2024/anniversary/Anniversary35C.png": "7eec",
	"./news/2024/anniversary/Anniversary35D.png": "09bb",
	"./news/SeafarersHeroesOfPandemic2_7-9-2021.jpg": "b59c",
	"./news/SeafarersHeroesOfPandemic_7-9-2021.jpg": "674d",
	"./news/SeafarersHeroes_home.jpg": "abfc",
	"./news/TeodoroLocsinMessage25June2021.jpg": "e20b",
	"./news/TeodoroLocsinMessage_home.jpg": "72ea",
	"./news/govt_advisory_template.jpg": "3c7a",
	"./news/medalist_cv_tokyo2020-08_08_2021.jpg": "6e6f",
	"./news/medalist_tokyo2020-08_08_2021.jpg": "15d2",
	"./news/newsStaff_7-10-2021.jpg": "7900",
	"./news/news_10-03-2021.jpg": "eeba",
	"./news/news_17-06-2019.jpg": "7c09",
	"./news/news_28-04-2021-30thAnniversary.jpg": "1872",
	"./news/news_28-04-2021-XmasParty.jpg": "dfb9",
	"./news/news_31-03-2021.jpg": "c7f0",
	"./news/news_bg_7-7-2021.jpg": "3abc",
	"./news/representative_tokyo2020-08_08_2021.jpg": "e1f2",
	"./news/tagaveritasako_7-9-2021.jpg": "aa29",
	"./news/weightlifting_07-28-2021.jpg": "1aaa",
	"./news/weightlifting_orig_07-28-2021.jpg": "c175",
	"./news_container.jpg": "848ba",
	"./no_image.jpg": "df9e",
	"./one_crew_onboard.jpg": "a455",
	"./principals/fujitrans_logo.jpg": "763c",
	"./principals/kline_krbs_logo.jpg": "034c",
	"./principals/sancho_kaiun_logo.jpg": "e5dcc",
	"./profile-black.png": "a713",
	"./profile-white.png": "eb33",
	"./programs/allottees/2015_bicol.jpg": "289d",
	"./programs/allottees/2015_davao.jpg": "12b7",
	"./programs/allottees/2016_alloottees_bacolod.jpg": "d290",
	"./programs/allottees/2016_alloottees_bohol.jpg": "b9fc",
	"./programs/allottees/2016_alloottees_cebu.jpg": "54fb",
	"./programs/allottees/2016_alloottees_gma.jpg": "7c397",
	"./programs/allottees/2016_alloottees_iloilo.jpg": "78cc",
	"./programs/allottees/2017_bicol.jpg": "85dd",
	"./programs/allottees/2017_cdo.jpg": "ec22",
	"./programs/allottees/2017_dvo.jpg": "c897",
	"./programs/allottees/2018/bacolod/allottee1_7-8-2021.jpg": "cb39",
	"./programs/allottees/2018/bacolod/allottee2_7-8-2021.jpg": "db1b",
	"./programs/allottees/2018/bacolod/allottee3_7-8-2021.jpg": "23a3",
	"./programs/allottees/2018/bicol/allottee1_7-8-2021.jpg": "6eb3",
	"./programs/allottees/2018/bicol/allottee2_7-8-2021.jpg": "1860",
	"./programs/allottees/2018/bicol/allottee3_7-8-2021.jpg": "2240",
	"./programs/allottees/2018/bohol/allottee1_7-8-2021.jpg": "8e46",
	"./programs/allottees/2018/bohol/allottee2_7-8-2021.jpg": "34b2",
	"./programs/allottees/2018/cdo/allottee1_7-8-2021.jpg": "f4da",
	"./programs/allottees/2018/cdo/allottee2_7-8-2021.jpg": "cfa6",
	"./programs/allottees/2018/cdo/allottee3_7-8-2021.jpg": "21df",
	"./programs/allottees/2018/cebu/allottee1_7-8-2021.jpg": "a7a3",
	"./programs/allottees/2018/cebu/allottee2_7-8-2021.jpg": "2a8f4",
	"./programs/allottees/2018/cebu/allottee3_7-8-2021.jpg": "f56a",
	"./programs/allottees/2018/cebu/allottee4_7-8-2021.jpg": "eedd",
	"./programs/allottees/2018/davao/allottee1_7-8-2021.jpg": "57ff",
	"./programs/allottees/2018/davao/allottee2_7-8-2021.jpg": "30aa1",
	"./programs/allottees/2018/davao/allottee3_7-8-2021.jpg": "737e",
	"./programs/allottees/2018/iloilo/allottee1_7-8-2021.jpg": "762c",
	"./programs/allottees/2018/iloilo/allottee2_7-8-2021.jpg": "31c2",
	"./programs/allottees/2018/iloilo/allottee3_7-8-2021.jpg": "3fa9",
	"./programs/allottees/2018/iloilo/allottee4_7-8-2021.jpg": "f060",
	"./programs/allottees/2019/bacolod/allottee1_7-8-2021.jpg": "b02f",
	"./programs/allottees/2019/bacolod/allottee2_7-8-2021.jpg": "6a6c",
	"./programs/allottees/2019/bacolod/allottee3_7-8-2021.jpg": "d8fb",
	"./programs/allottees/2019/bohol/allottee1_7-8-2021.jpg": "3b49",
	"./programs/allottees/2019/bohol/allottee2_7-8-2021.jpg": "f8c1",
	"./programs/allottees/2019/bohol/allottee3_7-8-2021.jpg": "c515",
	"./programs/allottees/2019/bohol/allottee4_7-8-2021.jpg": "ca50",
	"./programs/allottees/2019/cebu/allottee1_7-8-2021.jpg": "2df8",
	"./programs/allottees/2019/cebu/allottee2_7-8-2021.jpg": "f08c",
	"./programs/allottees/2019/cebu/allottee3_7-8-2021.jpg": "e96f",
	"./programs/allottees/2019/davao/allottee1_7-8-2021.jpg": "14bf",
	"./programs/allottees/2019/davao/allottee2_7-8-2021.jpg": "4e8f",
	"./programs/allottees/2019/davao/allottee3_7-8-2021.jpg": "82bf",
	"./programs/allottees/2019/davao/allottee4_7-8-2021.jpg": "3361",
	"./programs/allottees/2019/iloilo/allottee1_7-8-2021.jpg": "d096",
	"./programs/allottees/2019/iloilo/allottee2_7-8-2021.jpg": "f282",
	"./programs/allottees/2019/iloilo/allottee3_7-8-2021.jpg": "2327",
	"./programs/allottees/2019/iloilo/allottee4_7-8-2021.jpg": "4410",
	"./programs/allottees/2019/manila/allottee1_7-8-2021.jpg": "1728",
	"./programs/allottees/2019/manila/allottee2_7-8-2021.jpg": "fbd7",
	"./programs/allottees/2019/manila/allottee3_7-8-2021.jpg": "3d55",
	"./programs/allottees/2019/manila/allottee4_7-8-2021.jpg": "6c78",
	"./programs/allottees/2019/manila/allottee5_7-8-2021.jpg": "d5dd",
	"./programs/allottees/2020/all_a_70121.jpg": "eb51",
	"./programs/allottees/2020/all_b_70121.jpg": "71b0",
	"./programs/allottees/2020/all_c_70121.jpg": "29f3",
	"./programs/allottees/2020/all_d_70121.jpg": "772a",
	"./programs/allottees/2020/all_e_70121.jpg": "fc27",
	"./programs/allottees/2020/all_f_70121.jpg": "da97",
	"./programs/allottees/2020/iloilo_a_70121.jpg": "0e3d",
	"./programs/allottees/2020/iloilo_b_70121.jpg": "ff8a",
	"./programs/allottees/2020/iloilo_c_70121.jpg": "ef38",
	"./programs/allottees/2021/2021AlloteeVisayasTiktok.jpg": "4cdd",
	"./programs/allottees/2021/2021AllotteeOthers.jpg": "4684",
	"./programs/allottees/2021/2021AllotteeOthersInvitation.jpg": "6066",
	"./programs/allottees/2021/2021AllotteeOthersTiktok.jpg": "71eb",
	"./programs/allottees/2021/2021AllotteeVisayas.jpg": "9c11",
	"./programs/allottees/2021/2021AllotteeVisayasInvitation.jpg": "4d87",
	"./programs/allottees/2022/medmission/medMission_041022_A.jpg": "952e",
	"./programs/allottees/2022/medmission/medMission_041022_B.jpg": "3d8df",
	"./programs/allottees/2022/medmission/medMission_041022_C.jpg": "05f2",
	"./programs/allottees/2022/medmission/medMission_041022_D.jpg": "3a93",
	"./programs/allottees/2022/medmission/medMission_041022_E.jpg": "9217",
	"./programs/allottees/2022/medmission/medMission_041022_F.jpg": "07da",
	"./programs/allottees/2022/medmission/medMission_041022_G.jpg": "2319",
	"./programs/allottees/2022/medmission/medMission_041022_H.jpg": "5d9c",
	"./programs/allottees/2022/medmission/medMission_041022_I.jpg": "c84f",
	"./programs/allottees/2022/party/aParty_1208_A.jpg": "88fc",
	"./programs/allottees/2022/party/aParty_1208_B.jpg": "2e16",
	"./programs/allottees/2022/party/aParty_1208_C.jpg": "c9d2",
	"./programs/allottees/2022/party/aParty_1208_D.jpg": "fd80",
	"./programs/allottees/2022/party/aParty_1208_E.jpg": "b8eb",
	"./programs/allottees/2022/party/aParty_1208_F.jpg": "d61e",
	"./programs/allottees/2022/party/aParty_1208_G.jpg": "f8f8",
	"./programs/allottees/2022/party/aParty_1208_H.jpg": "b77d",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty1.jpg": "87a2",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty10.jpg": "0dd6",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty11.jpg": "8fa1",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty12.jpg": "4572",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty13.jpg": "e037",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty14.jpg": "b94d",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty15.jpg": "d4dd",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty16.jpg": "e449",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty17.jpg": "228e",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty18.jpg": "5844",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty19.jpg": "b812",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty2.jpg": "2678",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty20.jpg": "89ab",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty21.jpg": "0186",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty3.jpg": "395a",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty4.jpg": "9012",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty5.jpg": "dd49",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty6.jpg": "83f6",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty7.jpg": "df51",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty8.jpg": "6053",
	"./programs/allottees/2022/xmasparty/crewFamilyXmasParty9.jpg": "b36e",
	"./programs/allottees/2023/bacolod/aParty_111523_A.jpg": "9f10",
	"./programs/allottees/2023/bacolod/aParty_111523_B.jpg": "d5e5",
	"./programs/allottees/2023/bacolod/aParty_111523_C.jpg": "bdd3",
	"./programs/allottees/2023/bacolod/aParty_111523_D.jpg": "3287",
	"./programs/allottees/2023/bacolod/aParty_111523_E.jpg": "0aa1",
	"./programs/allottees/2023/bacolod/aParty_111523_F.jpg": "c33e",
	"./programs/allottees/2023/bacolod/aParty_111523_G.jpg": "6a54",
	"./programs/allottees/2023/bacolod/aParty_111523_H.jpg": "c3752",
	"./programs/allottees/2023/bacolod/aParty_111523_I.jpg": "be93",
	"./programs/allottees/2023/bacolod/aParty_111523_J.jpg": "2754",
	"./programs/allottees/2023/bohol/aParty_110923_A.jpg": "dac3",
	"./programs/allottees/2023/bohol/aParty_110923_B.jpg": "978e",
	"./programs/allottees/2023/bohol/aParty_110923_C.jpg": "fb4d",
	"./programs/allottees/2023/bohol/aParty_110923_D.jpg": "4241",
	"./programs/allottees/2023/bohol/aParty_110923_E.jpg": "e3c2",
	"./programs/allottees/2023/bohol/aParty_110923_F.jpg": "5a43",
	"./programs/allottees/2023/bohol/aParty_110923_G.jpg": "8047",
	"./programs/allottees/2023/bohol/aParty_110923_H.jpg": "9351",
	"./programs/allottees/2023/bohol/aParty_110923_I.jpg": "552b",
	"./programs/allottees/2023/bohol/aParty_110923_J.jpg": "8637",
	"./programs/allottees/2023/cdo/aParty_091123_A.jpg": "ad0a",
	"./programs/allottees/2023/cdo/aParty_091123_B.jpg": "f386",
	"./programs/allottees/2023/cdo/aParty_091123_C.jpg": "c439",
	"./programs/allottees/2023/cdo/aParty_091123_D.jpg": "04cd",
	"./programs/allottees/2023/cdo/aParty_091123_E.jpg": "1997",
	"./programs/allottees/2023/cdo/aParty_091123_F.jpg": "ac01",
	"./programs/allottees/2023/cdo/aParty_091123_G.jpg": "922b",
	"./programs/allottees/2023/cdo/aParty_091123_H.jpg": "0449",
	"./programs/allottees/2023/cebu/aParty_110523_A.jpg": "34dc",
	"./programs/allottees/2023/cebu/aParty_110523_B.jpg": "0682",
	"./programs/allottees/2023/cebu/aParty_110523_C.jpg": "dea1",
	"./programs/allottees/2023/cebu/aParty_110523_D.jpg": "25ad",
	"./programs/allottees/2023/cebu/aParty_110523_E.jpg": "84ed",
	"./programs/allottees/2023/cebu/aParty_110523_F.jpg": "20d9",
	"./programs/allottees/2023/cebu/aParty_110523_G.jpg": "ac3f",
	"./programs/allottees/2023/cebu/aParty_110523_H.jpg": "30ef",
	"./programs/allottees/2023/cebu/aParty_110523_I.jpg": "42f0",
	"./programs/allottees/2023/cebu/aParty_110523_J.jpg": "edd9",
	"./programs/allottees/2023/cebu/aParty_110523_K.jpg": "dc1b",
	"./programs/allottees/2023/davao/aParty_032523_A.jpg": "d492",
	"./programs/allottees/2023/davao/aParty_032523_B.jpg": "0705",
	"./programs/allottees/2023/davao/aParty_032523_C.jpg": "a4a2",
	"./programs/allottees/2023/davao/aParty_032523_D.jpg": "ee60",
	"./programs/allottees/2023/davao/aParty_032523_E.jpg": "67d8",
	"./programs/allottees/2023/davao/aParty_032523_F.jpg": "567d",
	"./programs/allottees/2023/davao/aParty_032523_G.jpg": "843d",
	"./programs/allottees/2023/davao/aParty_032523_H.jpg": "08a1",
	"./programs/allottees/2023/davao/aParty_032523_I.jpg": "9101",
	"./programs/allottees/2023/davao/aParty_032523_J.jpg": "c9cf",
	"./programs/allottees/2023/gma/aParty_121223_A.jpg": "3eb3",
	"./programs/allottees/2023/gma/aParty_121223_B.jpg": "d56d",
	"./programs/allottees/2023/gma/aParty_121223_C.jpg": "4cc2",
	"./programs/allottees/2023/gma/aParty_121223_D.jpg": "40d3",
	"./programs/allottees/2023/gma/aParty_121223_E.jpg": "4ad8",
	"./programs/allottees/2023/gma/aParty_121223_F.jpg": "15f0",
	"./programs/allottees/2023/gma/aParty_121223_G.jpg": "478f",
	"./programs/allottees/2023/gma/aParty_121223_H.jpg": "a10e",
	"./programs/allottees/2023/gma/aParty_121223_I.jpg": "8dfd",
	"./programs/allottees/2023/gma/aParty_121223_J.jpg": "8b03",
	"./programs/allottees/2023/iloilo/aParty_111223_A.jpg": "009e",
	"./programs/allottees/2023/iloilo/aParty_111223_B.jpg": "73ad",
	"./programs/allottees/2023/iloilo/aParty_111223_C.jpg": "e535",
	"./programs/allottees/2023/iloilo/aParty_111223_D.jpg": "7be0",
	"./programs/allottees/2023/iloilo/aParty_111223_E.jpg": "693c",
	"./programs/allottees/2023/iloilo/aParty_111223_F.jpg": "dce2",
	"./programs/allottees/2023/iloilo/aParty_111223_G.jpg": "0ec1",
	"./programs/allottees/2023/iloilo/aParty_111223_H.jpg": "2772",
	"./programs/allottees/2024/BACOLOD.jpg": "7896",
	"./programs/allottees/2024/BOHOL.jpg": "f95b",
	"./programs/allottees/2024/CDO.jpg": "a68a",
	"./programs/allottees/2024/CEBU.jpg": "d0f5",
	"./programs/allottees/2024/GMA.jpg": "9256",
	"./programs/allottees/2024/ILOILO.jpg": "6188",
	"./programs/allottees/2024/davao/aParty_042724_A.jpg": "25fc",
	"./programs/allottees/2024/davao/aParty_042724_B.jpg": "05ff",
	"./programs/allottees/2024/davao/aParty_042724_C.jpg": "245d",
	"./programs/allottees/2024/davao/aParty_042724_D.jpg": "8028",
	"./programs/allottees/2024/davao/aParty_042724_E.jpg": "289b",
	"./programs/allottees/2024/davao/aParty_042724_F.jpg": "c16b",
	"./programs/csr/2017/bacolodtreeplant/treeplant1_7-8-2021.jpg": "f549",
	"./programs/csr/2017/bacolodtreeplant/treeplant2_7-8-2021.jpg": "74ca",
	"./programs/csr/2017/bacolodtreeplant/treeplant3_7-8-2021.jpg": "c195",
	"./programs/csr/2017/bacolodtreeplant/treeplant4_7-8-2021.jpg": "3c38",
	"./programs/csr/2017/bacolodtreeplant/treeplant5_7-8-2021.jpg": "e14e",
	"./programs/csr/2017/bacolodtreeplant/treeplant6_7-8-2021.jpg": "7f64",
	"./programs/csr/2017/coastalcleanup/cleanup1-7-8-2021.jpg": "9fb1",
	"./programs/csr/2017/coastalcleanup/cleanup10-7-8-2021.jpg": "9b5c",
	"./programs/csr/2017/coastalcleanup/cleanup2-7-8-2021.jpg": "05a7",
	"./programs/csr/2017/coastalcleanup/cleanup3-7-8-2021.jpg": "c1de",
	"./programs/csr/2017/coastalcleanup/cleanup4-7-8-2021.jpg": "6447",
	"./programs/csr/2017/coastalcleanup/cleanup5-7-8-2021.jpg": "84ec",
	"./programs/csr/2017/coastalcleanup/cleanup6-7-8-2021.jpg": "cc2b",
	"./programs/csr/2017/coastalcleanup/cleanup7-7-8-2021.jpg": "d8d6",
	"./programs/csr/2017/coastalcleanup/cleanup8-7-8-2021.jpg": "c0b9",
	"./programs/csr/2017/coastalcleanup/cleanup9-7-8-2021.jpg": "5db5",
	"./programs/csr/2018/cebutreeplant/treeplant1_7-8-2021.jpg": "7b90",
	"./programs/csr/2018/cebutreeplant/treeplant2_7-8-2021.jpg": "b1b1",
	"./programs/csr/2018/cebutreeplant/treeplant3_7-8-2021.jpg": "cb8e",
	"./programs/csr/2018/cebutreeplant/treeplant4_7-8-2021.jpg": "b27b",
	"./programs/csr/2018/coastalcleanup/cleanup1-7-8-2021.jpg": "62c6",
	"./programs/csr/2018/coastalcleanup/cleanup2-7-8-2021.jpg": "aef1",
	"./programs/csr/2018/coastalcleanup/cleanup3-7-8-2021.jpg": "c12d",
	"./programs/csr/2018/coastalcleanup/cleanup4-7-8-2021.jpg": "0938",
	"./programs/csr/2018/coastalcleanup/cleanup5-7-8-2021.jpg": "dd74",
	"./programs/csr/2018/coastalcleanup/cleanup6-7-8-2021.jpg": "2e1b",
	"./programs/csr/2018/iloilotreeplant/treeplant1_7-8-2021.jpg": "67d5",
	"./programs/csr/2018/iloilotreeplant/treeplant2_7-8-2021.jpg": "0612",
	"./programs/csr/2018/iloilotreeplant/treeplant3_7-8-2021.jpg": "628a",
	"./programs/csr/2018/iloilotreeplant/treeplant4_7-8-2021.jpg": "6a20",
	"./programs/csr/2018/iloilotreeplant/treeplant5_7-8-2021.jpg": "e701",
	"./programs/csr/2018/iloilotreeplant/treeplant6_7-8-2021.jpg": "10f4",
	"./programs/csr/2018/iloilotreeplant/treeplant7_7-8-2021.jpg": "441d",
	"./programs/csr/2018/iloilotreeplant/treeplant8_7-8-2021.jpg": "4f96",
	"./programs/csr/2019/dentalmission/dental10_7-8-2021.jpg": "5750",
	"./programs/csr/2019/dentalmission/dental1_7-8-2021.jpg": "03f3",
	"./programs/csr/2019/dentalmission/dental2_7-8-2021.jpg": "88d9",
	"./programs/csr/2019/dentalmission/dental3_7-8-2021.jpg": "1141",
	"./programs/csr/2019/dentalmission/dental4_7-8-2021.jpg": "efec",
	"./programs/csr/2019/dentalmission/dental5_7-8-2021.jpg": "7588",
	"./programs/csr/2019/dentalmission/dental6_7-8-2021.jpg": "6f66",
	"./programs/csr/2019/dentalmission/dental7_7-8-2021.jpg": "c6ac",
	"./programs/csr/2019/dentalmission/dental8_7-8-2021.jpg": "e025",
	"./programs/csr/2019/dentalmission/dental9_7-8-2021.jpg": "860a",
	"./programs/csr/2019/indigent_outreach/indigent1_7-8-2021.jpg": "f520",
	"./programs/csr/2019/indigent_outreach/indigent2_7-8-2021.jpg": "abe7",
	"./programs/csr/2019/indigent_outreach/indigent3_7-8-2021.jpg": "26a9",
	"./programs/csr/2019/indigent_outreach/indigent4_7-8-2021.jpg": "f75b",
	"./programs/csr/2019/indigent_outreach/indigent5_7-8-2021.jpg": "bf619",
	"./programs/csr/2019/indigent_outreach/indigent6_7-8-2021.jpg": "8b99",
	"./programs/csr/2019/indigent_outreach/indigent7_7-8-2021.jpg": "68c5",
	"./programs/csr/2019/manilabaycleanup/Manila Bay Clean Up Drive 3.jpg": "0eb8",
	"./programs/csr/2019/manilabaycleanup/Manila Bay Cleanup Drive 2.jpg": "b542",
	"./programs/csr/2019/manilabaycleanup/Manila-Bay-Clean-Up-Drive-1.jpg": "ff31",
	"./programs/csr/2019/missonaries/missionaries10_2019_7-7-2021.jpg": "5e94",
	"./programs/csr/2019/missonaries/missionaries11_2019_7-7-2021.jpg": "ef43",
	"./programs/csr/2019/missonaries/missionaries12_2019_7-7-2021.jpg": "1a7c",
	"./programs/csr/2019/missonaries/missionaries13_2019_7-7-2021.jpg": "6cc0",
	"./programs/csr/2019/missonaries/missionaries14_2019_7-7-2021.jpg": "711a",
	"./programs/csr/2019/missonaries/missionaries15_2019_7-7-2021.jpg": "b1c7",
	"./programs/csr/2019/missonaries/missionaries16_2019_7-7-2021.jpg": "398e",
	"./programs/csr/2019/missonaries/missionaries17_2019_7-7-2021.jpg": "5fd6",
	"./programs/csr/2019/missonaries/missionaries18_2019_7-7-2021.jpg": "157c",
	"./programs/csr/2019/missonaries/missionaries19_2019_7-7-2021.jpg": "5ac5",
	"./programs/csr/2019/missonaries/missionaries1_2019_7-7-2021.jpg": "799c",
	"./programs/csr/2019/missonaries/missionaries20_2019_7-7-2021.jpg": "18f1",
	"./programs/csr/2019/missonaries/missionaries21_2019_7-7-2021.jpg": "451d",
	"./programs/csr/2019/missonaries/missionaries22_2019_7-7-2021.jpg": "b915",
	"./programs/csr/2019/missonaries/missionaries23_2019_7-7-2021.jpg": "2c24",
	"./programs/csr/2019/missonaries/missionaries24_2019_7-7-2021.jpg": "f41e",
	"./programs/csr/2019/missonaries/missionaries25_2019_7-7-2021.jpg": "e347",
	"./programs/csr/2019/missonaries/missionaries26_2019_7-7-2021.jpg": "bc35",
	"./programs/csr/2019/missonaries/missionaries27_2019_7-7-2021.jpg": "ff0a",
	"./programs/csr/2019/missonaries/missionaries28_2019_7-7-2021.jpg": "f421",
	"./programs/csr/2019/missonaries/missionaries29_2019_7-7-2021.jpg": "4479",
	"./programs/csr/2019/missonaries/missionaries2_2019_7-7-2021.jpg": "bf1f",
	"./programs/csr/2019/missonaries/missionaries30_2019_7-7-2021.jpg": "af52",
	"./programs/csr/2019/missonaries/missionaries31_2019_7-7-2021.jpg": "c71c",
	"./programs/csr/2019/missonaries/missionaries32_2019_7-7-2021.jpg": "7e95",
	"./programs/csr/2019/missonaries/missionaries33_2019_7-7-2021.jpg": "d6bb",
	"./programs/csr/2019/missonaries/missionaries3_2019_7-7-2021.jpg": "41ef",
	"./programs/csr/2019/missonaries/missionaries4_2019_7-7-2021.jpg": "da4e",
	"./programs/csr/2019/missonaries/missionaries5_2019_7-7-2021.jpg": "2174",
	"./programs/csr/2019/missonaries/missionaries6_2019_7-7-2021.jpg": "da29",
	"./programs/csr/2019/missonaries/missionaries7_2019_7-7-2021.jpg": "7566",
	"./programs/csr/2019/missonaries/missionaries8_2019_7-7-2021.jpg": "f3e4",
	"./programs/csr/2019/missonaries/missionaries9_2019_7-7-2021.jpg": "f4cb",
	"./programs/csr/2020/missionariesofpoor/missionaries1_7-10-2021.jpg": "44ce",
	"./programs/csr/2021/healthwealth/health10_7-9-2021.jpg": "c2f4",
	"./programs/csr/2021/healthwealth/health11_7-9-2021.jpg": "786a",
	"./programs/csr/2021/healthwealth/health12_7-9-2021.jpg": "022e",
	"./programs/csr/2021/healthwealth/health13_7-9-2021.jpg": "a4ad",
	"./programs/csr/2021/healthwealth/health14_7-9-2021.jpg": "dc8e",
	"./programs/csr/2021/healthwealth/health15_7-9-2021.jpg": "b50c",
	"./programs/csr/2021/healthwealth/health16_7-9-2021.jpg": "dd73",
	"./programs/csr/2021/healthwealth/health17_7-9-2021.jpg": "abae",
	"./programs/csr/2021/healthwealth/health18_7-9-2021.jpg": "136e",
	"./programs/csr/2021/healthwealth/health19_7-9-2021.jpg": "04c9",
	"./programs/csr/2021/healthwealth/health1_7-9-2021.jpg": "4b01",
	"./programs/csr/2021/healthwealth/health20_7-9-2021.jpg": "b350",
	"./programs/csr/2021/healthwealth/health21_7-9-2021.jpg": "89d3",
	"./programs/csr/2021/healthwealth/health22_7-9-2021.jpg": "0afb",
	"./programs/csr/2021/healthwealth/health23_7-9-2021.jpg": "c043",
	"./programs/csr/2021/healthwealth/health24_7-9-2021.jpg": "15c7",
	"./programs/csr/2021/healthwealth/health25_7-9-2021.jpg": "fef7",
	"./programs/csr/2021/healthwealth/health26_7-9-2021.jpg": "8075",
	"./programs/csr/2021/healthwealth/health27_7-9-2021.jpg": "c762",
	"./programs/csr/2021/healthwealth/health28_7-9-2021.jpg": "7018",
	"./programs/csr/2021/healthwealth/health29_7-9-2021.jpg": "c2e3",
	"./programs/csr/2021/healthwealth/health2_7-9-2021.jpg": "78eb",
	"./programs/csr/2021/healthwealth/health30_7-9-2021.jpg": "f303",
	"./programs/csr/2021/healthwealth/health31_7-9-2021.jpg": "f87b",
	"./programs/csr/2021/healthwealth/health32_7-9-2021.jpg": "0281",
	"./programs/csr/2021/healthwealth/health33_7-9-2021.jpg": "010b",
	"./programs/csr/2021/healthwealth/health34_7-9-2021.jpg": "e488",
	"./programs/csr/2021/healthwealth/health35_7-9-2021.jpg": "58c0",
	"./programs/csr/2021/healthwealth/health36_7-9-2021.jpg": "28e5",
	"./programs/csr/2021/healthwealth/health37_7-9-2021.jpg": "8e30",
	"./programs/csr/2021/healthwealth/health38_7-9-2021.jpg": "e8ea",
	"./programs/csr/2021/healthwealth/health3_7-9-2021.jpg": "d4e9",
	"./programs/csr/2021/healthwealth/health4_7-9-2021.jpg": "1d4d",
	"./programs/csr/2021/healthwealth/health5_7-9-2021.jpg": "d37e",
	"./programs/csr/2021/healthwealth/health6_7-9-2021.jpg": "b571",
	"./programs/csr/2021/healthwealth/health7_7-9-2021.jpg": "92c6",
	"./programs/csr/2021/healthwealth/health8_7-9-2021.jpg": "c310",
	"./programs/csr/2021/healthwealth/health9_7-9-2021.jpg": "0715",
	"./programs/csr/2022/bloodLetting/csr_121222_A.jpg": "7e53",
	"./programs/csr/2022/bloodLetting/csr_121222_B.jpg": "2c18",
	"./programs/csr/2022/bloodLetting/csr_121222_C.jpg": "0ac0",
	"./programs/csr/2022/cleanup/coastCleanUp_041022_A.jpg": "6e57",
	"./programs/csr/2022/cleanup/coastCleanUp_041022_B.jpg": "2ded",
	"./programs/csr/2022/cleanup/coastCleanUp_041022_C.jpg": "a974",
	"./programs/csr/2022/cleanup/coastCleanUp_041022_D.jpg": "e654",
	"./programs/csr/2022/cleanup/coastCleanUp_041022_E.jpg": "5932",
	"./programs/csr/2023/bacolod/csr_111123_A.jpg": "45a4",
	"./programs/csr/2023/bacolod/csr_111123_B.jpg": "28a8",
	"./programs/csr/2023/bacolod/csr_111123_C.jpg": "b3fd",
	"./programs/csr/2023/bacolod/csr_111123_D.jpg": "f113",
	"./programs/csr/2023/bacolod/csr_111123_E.jpg": "476e",
	"./programs/csr/2023/bacolod/csr_111123_F.jpg": "fcf8",
	"./programs/csr/2023/bacolod/csr_111123_G.jpg": "5b10",
	"./programs/csr/2023/bacolod/csr_111123_H.jpg": "b6b6",
	"./programs/csr/2023/bacolod/csr_111123_I.jpg": "342e",
	"./programs/csr/2023/bacolod/csr_111123_J.jpg": "00b7",
	"./programs/csr/2023/bohol/csr_110923_A.jpg": "30c7",
	"./programs/csr/2023/bohol/csr_110923_B.jpg": "3bbb",
	"./programs/csr/2023/bohol/csr_110923_C.jpg": "74d2",
	"./programs/csr/2023/bohol/csr_110923_D.jpg": "f6fb",
	"./programs/csr/2023/bohol/csr_110923_E.jpg": "14115",
	"./programs/csr/2023/bohol/csr_110923_F.jpg": "0562",
	"./programs/csr/2023/bohol/csr_110923_G.jpg": "e4f3",
	"./programs/csr/2023/bohol/csr_110923_H.jpg": "ee6f",
	"./programs/csr/2023/bohol/csr_110923_I.jpg": "70f8",
	"./programs/csr/2023/bohol/csr_110923_J.jpg": "c599",
	"./programs/csr/2023/davao/csr_032423_A.jpg": "400a",
	"./programs/csr/2023/davao/csr_032423_B.jpg": "a867",
	"./programs/csr/2023/davao/csr_032423_C.jpg": "2d05",
	"./programs/csr/2023/davao/csr_032423_D.jpg": "3078",
	"./programs/csr/2023/davao/csr_032423_E.jpg": "0b1f",
	"./programs/csr/2023/davao/csr_032423_F.jpg": "a86b",
	"./programs/csr/2024/BOHOLCSR.jpg": "7430",
	"./programs/csr/2024/ILOILOCSR.jpg": "57a6",
	"./programs/csr/SpecialChildrenXMasParty_2014.jpg": "676e",
	"./programs/csr/bakingLesson.jpg": "eeee",
	"./programs/office/2014-Loyalty-Awardee_18.jpg": "1647",
	"./programs/office/2017_hayatomo.jpg": "1dbb",
	"./programs/office/2017_horizon.jpg": "5274",
	"./programs/office/2019/firedrill/drill1_7-7-2021.jpg": "5ca5",
	"./programs/office/2019/firedrill/drill2_7-7-2021.jpg": "2546",
	"./programs/office/2019/firedrill/drill3_7-7-2021.jpg": "457d",
	"./programs/office/2019/firedrill/drill4_7-7-2021.jpg": "842c",
	"./programs/office/2019/firedrill/drill5_7-7-2021.jpg": "de9c",
	"./programs/office/2021/anniversary/vmc_aniv10_24Aug2021.jpg": "a5bd",
	"./programs/office/2021/anniversary/vmc_aniv11_24Aug2021.jpg": "096c",
	"./programs/office/2021/anniversary/vmc_aniv12_24Aug2021.jpg": "aeb4",
	"./programs/office/2021/anniversary/vmc_aniv13_24Aug2021.jpg": "309a",
	"./programs/office/2021/anniversary/vmc_aniv14_24Aug2021.jpg": "f0ea",
	"./programs/office/2021/anniversary/vmc_aniv15_24Aug2021.jpg": "df10",
	"./programs/office/2021/anniversary/vmc_aniv16_24Aug2021.jpg": "0003",
	"./programs/office/2021/anniversary/vmc_aniv17_24Aug2021.jpg": "477f",
	"./programs/office/2021/anniversary/vmc_aniv18_24Aug2021.jpg": "194f",
	"./programs/office/2021/anniversary/vmc_aniv19_24Aug2021.jpg": "cbe2",
	"./programs/office/2021/anniversary/vmc_aniv1_24Aug2021.jpg": "b461",
	"./programs/office/2021/anniversary/vmc_aniv20_24Aug2021.jpg": "99c1",
	"./programs/office/2021/anniversary/vmc_aniv21_24Aug2021.jpg": "263f",
	"./programs/office/2021/anniversary/vmc_aniv22_24Aug2021.jpg": "5d84",
	"./programs/office/2021/anniversary/vmc_aniv23_24Aug2021.jpg": "4051",
	"./programs/office/2021/anniversary/vmc_aniv24_24Aug2021.jpg": "03be",
	"./programs/office/2021/anniversary/vmc_aniv25_24Aug2021.jpg": "b50e",
	"./programs/office/2021/anniversary/vmc_aniv26_24Aug2021.jpg": "c329",
	"./programs/office/2021/anniversary/vmc_aniv27_24Aug2021.jpg": "e688",
	"./programs/office/2021/anniversary/vmc_aniv28_24Aug2021.jpg": "977d",
	"./programs/office/2021/anniversary/vmc_aniv2_24Aug2021.jpg": "7acb",
	"./programs/office/2021/anniversary/vmc_aniv3_24Aug2021.jpg": "98de",
	"./programs/office/2021/anniversary/vmc_aniv4_24Aug2021.jpg": "c4c9",
	"./programs/office/2021/anniversary/vmc_aniv5_24Aug2021.jpg": "ff37",
	"./programs/office/2021/anniversary/vmc_aniv6_24Aug2021.jpg": "9b67",
	"./programs/office/2021/anniversary/vmc_aniv7_24Aug2021.jpg": "4f7c",
	"./programs/office/2021/anniversary/vmc_aniv8_24Aug2021.jpg": "1454",
	"./programs/office/2021/anniversary/vmc_aniv9_24Aug2021.jpg": "04c6",
	"./programs/office/2021/healthwealth/health1_18-10-2021.jpg": "6297",
	"./programs/office/2021/healthwealth/health2_18-10-2021.jpg": "be37",
	"./programs/office/2021/loyaltyaward/AB_Avellaneda.jpg": "da2b",
	"./programs/office/2021/loyaltyaward/CAPT_Albay.jpg": "b606",
	"./programs/office/2021/loyaltyaward/CAPT_Daluz.jpg": "5173",
	"./programs/office/2021/loyaltyaward/CAPT_Panaguiton.jpg": "514a",
	"./programs/office/2021/loyaltyaward/CAPT_Suyat.jpg": "5181",
	"./programs/office/2022/seminar/writingSeminar_041022_A.jpg": "61f4",
	"./programs/office/2022/seminar/writingSeminar_041022_B.jpg": "6b33",
	"./programs/office/2022/seminar/writingSeminar_041022_C.jpg": "ba44",
	"./programs/office/2022/seminar/writingSeminar_041022_D.jpg": "d41f",
	"./programs/office/2022/seminar/writingSeminar_041022_E.jpg": "d0ef",
	"./programs/office/2022/seminar/writingSeminar_041022_F.jpg": "f53e",
	"./programs/office/2022/seminar/writingSeminar_041022_G.jpg": "f121",
	"./programs/office/2022/seminar/writingSeminar_041022_H.jpg": "18b6",
	"./programs/office/2022/seminar/writingSeminar_041022_I.jpg": "a5dc",
	"./programs/office/2022/seminar/writingSeminar_041022_J.jpg": "b54b",
	"./programs/office/2022/xmasparty/xmasParty1.jpg": "2848",
	"./programs/office/2022/xmasparty/xmasParty10.jpg": "85e9",
	"./programs/office/2022/xmasparty/xmasParty11.jpg": "f4c3",
	"./programs/office/2022/xmasparty/xmasParty12.jpg": "7b02",
	"./programs/office/2022/xmasparty/xmasParty13.jpg": "405f",
	"./programs/office/2022/xmasparty/xmasParty14.jpg": "db21",
	"./programs/office/2022/xmasparty/xmasParty15.jpg": "99b5",
	"./programs/office/2022/xmasparty/xmasParty16.jpg": "6ba0",
	"./programs/office/2022/xmasparty/xmasParty17.jpg": "d47b",
	"./programs/office/2022/xmasparty/xmasParty18.jpg": "dbd6",
	"./programs/office/2022/xmasparty/xmasParty19.jpg": "c07d",
	"./programs/office/2022/xmasparty/xmasParty2.jpg": "930a",
	"./programs/office/2022/xmasparty/xmasParty20.jpg": "32cc",
	"./programs/office/2022/xmasparty/xmasParty21.jpg": "bdfc",
	"./programs/office/2022/xmasparty/xmasParty3.jpg": "72a0",
	"./programs/office/2022/xmasparty/xmasParty4.jpg": "0a60",
	"./programs/office/2022/xmasparty/xmasParty5.jpg": "bfa1",
	"./programs/office/2022/xmasparty/xmasParty6.jpg": "79c7",
	"./programs/office/2022/xmasparty/xmasParty7.jpg": "4be0",
	"./programs/office/2022/xmasparty/xmasParty8.jpg": "4589",
	"./programs/office/2022/xmasparty/xmasParty9.jpg": "8bd0",
	"./programs/office/2023/xmasparty/xmasParty1.jpg": "8f37",
	"./programs/office/2023/xmasparty/xmasParty10.jpg": "f10f",
	"./programs/office/2023/xmasparty/xmasParty11.jpg": "2108",
	"./programs/office/2023/xmasparty/xmasParty12.jpg": "5eeb",
	"./programs/office/2023/xmasparty/xmasParty13.jpg": "1714",
	"./programs/office/2023/xmasparty/xmasParty14.jpg": "7260",
	"./programs/office/2023/xmasparty/xmasParty15.jpg": "b917",
	"./programs/office/2023/xmasparty/xmasParty16.jpg": "a20c",
	"./programs/office/2023/xmasparty/xmasParty17.jpg": "977e",
	"./programs/office/2023/xmasparty/xmasParty2.jpg": "1c15",
	"./programs/office/2023/xmasparty/xmasParty3.jpg": "488f",
	"./programs/office/2023/xmasparty/xmasParty4.jpg": "ae72",
	"./programs/office/2023/xmasparty/xmasParty5.jpg": "1084",
	"./programs/office/2023/xmasparty/xmasParty6.jpg": "1f7d",
	"./programs/office/2023/xmasparty/xmasParty7.jpg": "3b59",
	"./programs/office/2023/xmasparty/xmasParty8.jpg": "24ad4",
	"./programs/office/2023/xmasparty/xmasParty9.jpg": "3a75",
	"./programs/office/2024/xmasparty/xmasParty1.jpg": "3688",
	"./programs/office/2024/xmasparty/xmasParty10.jpg": "fb6e",
	"./programs/office/2024/xmasparty/xmasParty11.jpg": "49f9",
	"./programs/office/2024/xmasparty/xmasParty12.jpg": "4feb",
	"./programs/office/2024/xmasparty/xmasParty13.jpg": "6179",
	"./programs/office/2024/xmasparty/xmasParty14.jpg": "94d4",
	"./programs/office/2024/xmasparty/xmasParty15.jpg": "2344",
	"./programs/office/2024/xmasparty/xmasParty16.jpg": "a7e4",
	"./programs/office/2024/xmasparty/xmasParty17.jpg": "8abc",
	"./programs/office/2024/xmasparty/xmasParty18.jpg": "d205",
	"./programs/office/2024/xmasparty/xmasParty19.jpg": "ac76",
	"./programs/office/2024/xmasparty/xmasParty2.jpg": "892f",
	"./programs/office/2024/xmasparty/xmasParty20.jpg": "cb7f",
	"./programs/office/2024/xmasparty/xmasParty3.jpg": "e433",
	"./programs/office/2024/xmasparty/xmasParty4.jpg": "b385",
	"./programs/office/2024/xmasparty/xmasParty5.jpg": "5e19",
	"./programs/office/2024/xmasparty/xmasParty6.jpg": "e0d9",
	"./programs/office/2024/xmasparty/xmasParty7.jpg": "5029",
	"./programs/office/2024/xmasparty/xmasParty8.jpg": "8295",
	"./programs/office/2024/xmasparty/xmasParty9.jpg": "7420",
	"./programs/office/30YearsFront.png": "e26d",
	"./programs/office/30YearsGroupPhoto.jpg": "ebd1",
	"./programs/office/JMMSoloSpeech.png": "a8a8",
	"./programs/office/JMMSpeech.png": "6e74",
	"./programs/office/cadets_teambuilding.jpg": "0b12",
	"./programs/office/corona_utility.jpg": "55be",
	"./programs/office/drive_green.jpg": "c61d",
	"./programs/office/shining_bliss.jpg": "5743",
	"./programs/office/vesselvisitation/vessel_visitation_10_63021.jpg": "f7ac1",
	"./programs/office/vesselvisitation/vessel_visitation_11_63021.jpg": "cd86",
	"./programs/office/vesselvisitation/vessel_visitation_12_63021.jpg": "afdf",
	"./programs/office/vesselvisitation/vessel_visitation_13_63021.jpg": "461e",
	"./programs/office/vesselvisitation/vessel_visitation_1_63021.jpg": "316f",
	"./programs/office/vesselvisitation/vessel_visitation_1_63021_crop.jpg": "6ce3",
	"./programs/office/vesselvisitation/vessel_visitation_2_63021.jpg": "197f",
	"./programs/office/vesselvisitation/vessel_visitation_3_63021.jpg": "2d46",
	"./programs/office/vesselvisitation/vessel_visitation_4_63021.jpg": "c975",
	"./programs/office/vesselvisitation/vessel_visitation_5_63021.jpg": "77be",
	"./programs/office/vesselvisitation/vessel_visitation_6_63021.jpg": "5079",
	"./programs/office/vesselvisitation/vessel_visitation_7_63021.jpg": "c9a0",
	"./programs/office/vesselvisitation/vessel_visitation_8_63021.jpg": "28b8",
	"./programs/office/vesselvisitation/vessel_visitation_9_63021.jpg": "9605",
	"./programs/office/vmc25Anniversary.jpg": "c118",
	"./programs/office/vmcXmasParty2016.jpg": "d35d",
	"./programs/office/vmcXmasPartyHawaiian.jpg": "9408",
	"./schedules/2021/training/schedule1_7-12-2021.jpg": "725b",
	"./schedules/2021/training/schedule2_7-12-2021.jpg": "15f4",
	"./schedules/2022/training/Matrix-2022.jpg": "5792",
	"./schedules/2024/inHouseTrainingSchedule032124.jpg": "b76b",
	"./schedules/2025/bicolAllottee.jpg": "1dae",
	"./schedules/schedule_bg.jpg": "4ef1",
	"./ship404.png": "fce2",
	"./veritas_logo.png": "8050",
	"./veritas_pin.jpg": "c8f1",
	"./veritas_pin_covid19.jpg": "4ae3",
	"./vessel_cape_sasanqua.jpg": "aa96",
	"./vessel_corona_citrus.jpg": "be95",
	"./vessel_drive_green.jpg": "a6b7",
	"./vessel_floor.jpg": "6166",
	"./vessel_kline_wide.jpg": "09fd",
	"./vessel_new_century.jpg": "6716"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";